<template>
  <div class="background-div">

    <!-- 12052009 -->

    <!-- obj_clicado: {{ obj_clicado }} <br/> -->
    <!-- acao_global: {{ acao_global }} <br/> -->
    <!-- achou_cadastro: {{ achou_cadastro }} <br/> -->
    <!-- obj_empresa: {{ obj_empresa }} <br/> -->
    <!-- obj_dados_aluno: {{ obj_dados_aluno }} <br/> -->
    <!-- obj_dados_chamada: {{ obj_dados_chamada }} <br/> -->
    <!-- isMobile: {{ isMobile }} <br/> -->
    <!-- {{img_gerada}} -->
    <!-- url_geral: {{ url_geral }} -->
    <!-- qual_assinar:{{ qual_assinar }}<br/> -->
    <!-- obj_DADOS_ASSINATURA_1: {{ obj_DADOS_ASSINATURA_1 }} <br/><br/> -->
    <!-- obj_DADOS_ASSINATURA_2: {{ obj_DADOS_ASSINATURA_2 }} <br/><br/> -->
    <!-- ja_IMG_ASSINATURA_1: {{ ja_IMG_ASSINATURA_1 }} <br/> -->
    <!-- signatureDataURL: {{ signatureDataURL }} <br/> -->
    <!-- aceitou_geo: {{ aceitou_geo }} -->
    <!-- tabela_selecionada: {{tabela_selecionada  }} <br/><br/> -->
    <!-- dados_geo: {{dados_geo  }}<br/><br/> -->
    <!-- items_lista : {{ items_lista }} <br/><br/> -->
    <!-- items_editaveis : {{ items_editaveis }} <br/><br/> -->
    <!-- item_edita : {{ item_edita }} <br/><br/> -->
    {{ (TESTE)? 'TESTE':'' }}

    <v-app-bar height="70" color="blue" v-if="0>1">

    </v-app-bar>
  
    <!-- d-flex align-center justify-center -->
  <center class="pt-5 mx-10">



  <v-dialog
      v-model="dialog_opcoes"
      max-width="699px"
      scrollable
      persistent
  >
    <v-card
      class="mx-auto"
    >
      <v-card-title class=" grey lighten-5">
        <h5 class="mr-4"> {{ items_opcoes_titulo  }} de </h5>

        <h5 class="mr-4 primary--text" v-if="acao_global==402"> {{ obj_clicado.NOME  }} </h5>


        <v-spacer></v-spacer>
        
        <v-icon
          color="red"
          @click="dialog_opcoes=!dialog_opcoes"
          v-if="0>1"
        >
          mdi-close
        </v-icon>

      </v-card-title>

      <v-card-text>
        <v-container class="mx-0 px-0 mt-2">
          <v-row>
            

              <v-col class=""
                cols="12" 
              >   
                <v-text-field
                  v-model="items_opcoes.ID_CPF"
                  dense
                  label="ID (4 digitos do CPF)"
                  hide-details
                  type="text"
                  autofocus
                  @keyup.enter="clicou_em('validar_cpf')"
                ></v-text-field>
              </v-col>



            <v-col
              cols="12"
              md="4"
              class=" ml-auto"
            >      
            <v-btn color="primary"
               @click="clicou_em('validar_cpf')"
            >
             OK 
            </v-btn>

            <v-btn color="error" class="ml-5"
            @click="dialog_opcoes=!dialog_opcoes"
            >
              CANCELAR
            </v-btn>
            </v-col>      


          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>    


  <template>
    <div class="text-center">
      <v-dialog v-model="dialog_data_table"
      max-width="999px"
      persistent 
      :fullscreen="(isMobile)"
    >
      <!-- <v-container class="px-0 white"> -->
          <v-card
            class="mt-5 pb-5"
            color=""
            id="conteudo_impressao_2"
          >

            <v-card-title class="blue justify-center">
                <div class="text-center text-h6 font-weight-bold white--text">
                    {{ obj_empresa.nome }}
                </div>
            </v-card-title>


            <v-card-title class="grey lighten-4 px-3">

                <v-row dense class="">
                    <v-col class=""  cols="12" md="9">
                        <v-row class="">
                            <v-col class="primary--text">
                              
                              <v-chip :large="(isMobile)">  {{ card_titulo }}  </v-chip>
                              <span class="red--text mb-4 ml-1 fs-16"> {{ items_lista.length }} </span>
                              
                            </v-col>
                        </v-row>
                    </v-col>


                    <v-col class=""  cols="12" md="3">
                        <v-row class="">

                          <v-spacer/>
                            <v-col  cols="12" :class="(isMobile) ? 'mt-2' : ''">
                                <v-text-field
                                    dense
                                    v-model="search"
                                    clearable
                                    append-icon="mdi-magnify"
                                    label="Procurar"
                                    
                                    hide-details
                                    @keyup.esc="search=''"
                                    >
                                </v-text-field>
                            </v-col>

                            

                            <v-col v-if="0>1"  cols="3"  md="3" class="">
                                <v-btn
                                    color="primary"
                                    small
                                    @click="nova_tabela('item_edita','dialog_tabela')"
                                >
                                    Novo
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

            
            </v-card-title>


            <v-card-text class="pa-3">
            <div>
                <v-row>
                    <v-col>
                        <v-card>
                        <!-- passo 5 monto a lista -->
                            <v-data-table
                            v-model="selected"
                            item-key="CODIGO"
                            single-select
                            
                            @click:row="seleciona_linha"

                            fixed-header
                            :headers="items_header"
                            :items="items_lista"
                            
                            :height="retorna_altura( (isMobile)? '150' : '200')"

                            class="elevation-1"
                            :items-per-page="500"
                            disable-sort
                            :mobile-breakpoint="55"
                            
                            hide-default-footer
                            :search="search"
                            dense
                            >
                            

                                <template v-slot:item.VISTO="{ item }">
                                  <div>
                                      <v-icon  color="green" v-if="(item.VISTO=='S')">
                                        <!-- mdi-check-bold  -->
                                         mdi-check-circle
                                      </v-icon>
                                      <v-icon   v-else color="orange">
                                        mdi-radiobox-blank 
                                      </v-icon>
                                  </div>
                              </template>



                                <template v-slot:item.NOME="{ item }">
                                  <a class="font-weight-medium" @click="clicou_em('clicou_nome', item)">
                                        {{ item.NOME }}
                                  </a>
                                </template>

                                

                                <template v-slot:item.actions="{ item }">
                                    <v-icon
                                        class="mr-2"
                                        @click="editar_tabela(item, 'item_edita', 'dialog_tabela')"
                                        color="blue"
                                        size = "22"
                                    >
                                    mdi-pencil
                                    </v-icon>
                                </template>


                            </v-data-table>

                        </v-card>

                    </v-col>
                </v-row>

            </div>
            </v-card-text>



            <v-card-actions>

              <v-row>
                <v-col class=" ml-auto" cols="auto">
                    <v-spacer/>
                    <v-btn color="primary" @click="dialog_data_table=false"> ok </v-btn>

                    <!-- <v-btn color="error" class="ml-4" @click="clicou_em('FECHAR_JANELA')"> fechar </v-btn> -->
                  </v-col>
                </v-row>


            
            </v-card-actions>
          </v-card>
      <!-- </v-container> -->
      </v-dialog>
    </div>
  </template>

  <template>
    <div class="text-center">
      <v-dialog v-model="dialog_comprovante"
      max-width="600"
      persistent
    >
      <!-- <v-container class="px-0 white"> -->
          <v-card
            class="mt-5 pb-5 px-3"
            color="#26c6da"
            dark
            
            id="conteudo_impressao"
          >
            <v-card-title>
              <v-icon
                large
                left
              >
                mdi-calendar
              </v-icon>

              <v-spacer/>
              <v-icon color="red" size="35" @click="clicou_em('FECHAR_JANELA')" v-if="(!ocultar_print)"> mdi-close</v-icon>

            </v-card-title>
            <h3 class="fs-28 text-center mb-3">Formulário enviado com Sucesso</h3>
            <!-- <h5 class="text-h6 white--text text-center">{{ parametros.NOME }}</h5> -->
            <center>
                <!-- <v-chip color="white" class="black--text fs-14 pa-4" :small="(isMobile)"> {{ obj_dados_aluno.NOME }} </v-chip> -->
                <v-chip color="white" class="black--text fs-14 pa-4" :small="(isMobile)"> {{ item_edita.NOME }} </v-chip>
            </center>

            <span class="ml-3">
              <!-- <span class="text-h4 font-weight-light"> {{ editedItem.NOME }} </span> -->

              <v-row class="ml-3">
                <v-col>

                    <!-- <v-card-title >Dados do Agendamento</v-card-title> -->
                    <!-- <h3>{{ parametros.NOME }}</h3> -->
                    <span class="text-h6 black--text">Dados do Agendamento</span>
                    
                    <v-chip-group column>
                        <v-chip :small="(isMobile)">{{ obj_dados_chamada.x_NOME_FORNECEDOR }}</v-chip>                
                        <v-chip :small="(isMobile)">{{ obj_dados_chamada.DESCRICAO }}</v-chip>                
                        <v-chip :small="(isMobile)">{{ obj_dados_chamada.x_DATA }}</v-chip>
                        <v-chip :small="(isMobile)">{{ obj_dados_chamada.HORA }}</v-chip>
                    </v-chip-group>

                    <!-- <hr/> -->
                    <v-divider class="mr-5 my-2 black"></v-divider>


                </v-col>
            </v-row>

            </span>


            <v-card-text class="text-h6 font-weight-bold text-center white--text">
                <div>Solicitação em Análise.</div>
                Aguarde contato via WhatsApp
                <!-- <div class="red--text text--accent-3"> ID: {{ ID_ONLINE_HERE }} </div> -->
                <div class="yellow--text "> 
                    <span class="white--text fs-16">CÓDIGO:</span>
                    {{ ID_ONLINE_HERE }} 
                 </div>
                <!-- <div class="yellow--text text--accent-3"> ID: {{ ID_ONLINE_HERE }} </div> -->
            </v-card-text>

            <v-card-actions >

                <v-spacer></v-spacer>
                <v-row>
                  <v-col>
                    <v-btn
                      color="orange" dark
                      @click="clicou_em('COMPARTILHAR_IMG')"
                      class=""
                      v-if="(!ocultar_print)"
                    >
                    <!-- @click="clicou_em('SALVAR_IMG')" -->
                      salvar comprovante
                    </v-btn>

                    <span class="px-1" v-if="(!ocultar_print && 0>1) ">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">

                          <v-btn small fab absolute right
                              color="orange" 
                              dark class="white mt-n1" 
                              v-bind="attrs" v-on="on"
                              @click="clicou_em('COMPARTILHAR_IMG')"
                          >
                              <v-icon color=""> mdi-share-variant </v-icon>
                          </v-btn>


                        </template>
                        <span> Compartilhar </span>
                      </v-tooltip>
                    </span>

                    <div v-if="(ocultar_print)">
                       {{ go_get_data_hora() }}
                    </div>

                  </v-col>
                </v-row>


              

                <v-row v-if="0>1"
                  align="center"
                  justify="end"
                >
                  <v-icon class="mr-1">
                    mdi-heart
                  </v-icon>
                  <span class="subheading mr-2">256</span>
                  <span class="mr-1">·</span>
                  <v-icon class="mr-1">
                    mdi-share-variant
                  </v-icon>
                  <span class="subheading">45</span>
                </v-row>
              </v-list-item>
            </v-card-actions>
          </v-card>
      <!-- </v-container> -->
      </v-dialog>
    </div>
  </template>


  <v-dialog v-model="dialog_assinar"
      max-width="600px"
      persistent
      scrollable 
    >
      <v-card 
        class="grey lighten-4"
        ref="cardWithCanvas">
        <v-card-title>
          Assinatura
        </v-card-title>

        <v-card-text class="px-0">
          <v-container>
            <v-row justify="center" dense>
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <v-row justify="center" >
                      <canvas ref="canvas" width="350" height="200" style="border: 1px solid #000;"></canvas>

                      <div
                          style="
                            position: absolute;
                            top: 90px;
                            left: 50%;
                            transform: translateX(-50%);
                            /* width: 200px; */
                            text-align: center;
                            pointer-events: none;
                          "
                        >
                        <center>
                          _____________________________________
                          <h5 style="text-align: center;" v-if="qual_assinar==1">{{ nome_assinar }}</h5>
                          <h5 style="text-align: center;" v-if="qual_assinar==2">{{ nome_empresa }}</h5>
                        </center>

                        <div style="margin-top:-82px">
                          <center>
                            <img
                              alt="ass_cadastro"
                              :src="(obj_empresa.ASSINATURA_EMPRESA)"
                              width="60%"
                              class=""
                              v-if="(obj_empresa.ASSINATURA_EMPRESA) && (qual_assinar==2)"
                            />
                          </center>
                        </div>

                        </div>



                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        
        <v-card-actions>
          
          
          <v-btn small color="orange white--text" @click="clearSignature">Limpar</v-btn>

          <v-spacer></v-spacer>

          <v-btn small color="error" @click="dialog_assinar=false">Cancelar</v-btn>
          <v-btn small color="primary" @click="saveSignature">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>




      <!-- CARD LOGO DSI -->
    <v-card
          :class="[(isMobile) ? '' : 'grey white--text text-center pa-0']"
          elevation="4"
          width="360"
          v-if="(versao_anterior)"
        >
        

        <v-row dense>
              <v-col cols="8" class="pr-0 pl-2">
                <v-card tile flat>
                  <v-card-title class="justify-center">
                    <div 
                      :class="[(isMobile) ? 'text-h5':'text-h3', 'font-weight-normal grey--text']"
                    >Sistemas</div>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="4" class="pl-0 pr-2">
                <v-card tile flat>
                  <v-card-title class="justify-center blue lighten-0 white--text" >
                    <div class="text-h3 font-weight-medium ">DSi</div>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>


          <div class="white pa-1" v-if="0>1">
            <v-row dense class="grey lighten-3 pa-0 ma-0">

              <v-col class="pa-1 px-2 grey lighten-3 mt-1">
                <span class="font-weight-regular pa-0 ma-0 text-h3 black--text">Sistemas</span>
              </v-col>

              <v-col class="pa-1 px-2 blue lighten-0">
                <span class="font-weight-regular pa-0 ml-1 text-h2">DSi</span>
              </v-col>

            </v-row>
          </div>
    </v-card>
    <v-divider class="grey pt-0 mt-5" v-if="(versao_anterior)"/>
  </center>



    <!-- NOME DA EMPRESA -->
    <h1 class="text-center mt-10" :class="[(isMobile) ? 'fs-28' : '']" v-if="(acao_global * 1)<=401"> 
      {{ nome_empresa }}
   </h1> 

    
    <div class="white--text mt-10" v-if="(TESTE)">
    
      obj_dados_cliente: {{ obj_dados_cliente }} <br/>
      {{ dialog_modal_acao }}
      {{ codigo_celular }}
      etapa:{{ etapa }} <br/>
      token:{{ token }} <br/>
      ide:{{ bd_here_cliente }} <br/>
      item_edita:{{ item_edita }} <br/><br/>
      {{ snack_timeout }}
    </div>



   <v-snackbar
     v-model="snackbar2"
     :timeout="snack_timeout"
     centered
     :color="snack_color" 
     :content-class="(snack_color=='yellow') ? 'black--text' : ''"
     >
    <center v-html="snack_text1"></center>

   </v-snackbar>


  <v-snackbar
  v-model="snackbar"
  :timeout="snack_timeout"
  :color="snack_color"   
  centered
  multi-line

  class="mb-4"
  attrs
  elevation="24"
  width="900px"
  >
  
    <!-- centered
  vertical
  multi-line -->

  <!-- {{ snack_text1 }}<br/>
  {{ snack_text2 }} -->

  <center v-html="snack_text1" class="text-h6"></center>
  <br/>
  <center v-html="snack_text2" class="text-h6" v-if="snack_text2"></center>


  <!-- <span  
    :class="[(isMobile) ? 'text-h6' :'text-h6']" style="font-weight: normal !important;">
  </span>
  <br/>
  <span v-if="snack_text2" :class="[(isMobile) ? 'text-h6' :'text-h6']" style="font-weight: normal !important;">{{ snack_text2 }} </span> -->
    

    <!-- <template v-slot:action="{ attrs }">
      <v-btn
          color=""
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          fechar
        </v-btn>
    </template> -->
  </v-snackbar>


  <div class="ml-3 mb-2 mt-10  text-center" v-if="(banner)">
    <v-chip large color="blue" dark class="pa-5" @click="dialog_tabela=true, banner=false, oi()">
        <!-- <h3> Assinar Agora</h3> -->
        <h3>
          Testar Grátis por 15 dias
        </h3>
    </v-chip>
  </div>


  <template v-if="(versao_anterior)">
        <br>
        <v-card
          class="mx-auto"
          color="blue"
          dark
          max-width="540"
          v-if="(banner)"
        >

        <v-img
          :src="backgroundImage"
          aspect-ratio="2.5"
          gradient="to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)"
        >
        
          <v-card-title>
            <v-icon
              left
              size="77"
              v-if="0>1"
            >
              mdi-calendar-clock
            </v-icon>
            <!-- <span class="text-h4 font-weight-bold yellow--text">Módulo</span>  -->
              
          </v-card-title>

          <div class="text-h4 text-center font-weight-bold ml-3 mt-1 blue--text">Gerenciador de CFC Online </div>

          <v-card-text class="text-h6 font-weight- text-left white--text">
          <span>
            <!-- Aumente a eficiência da sua <span class="white--text"> Clínica</span> com o Módulo Agendamento Online -->
            Aumente a produtividade no seu CFC e tenha tudo num só clique
          </span>

          <br/>
          <span>
            <!-- Sua agenda disponível para os pacientes 24h por dia, 7 dias por semana -->
          </span>
          
          </v-card-text>

          <v-card-text class="text-h6 font-weight-bold text-left grey--text">
              <!-- Mais agilidade no seu dia a dia  -->
              Mais eficiência à sua equipe
              <br/>
              <!-- Economize tempo valioso para sua equipe -->
              Mais tempo para você 
          </v-card-text>



          <v-card-text class="text-h6 font-weight- text-left white--text">
          <span>
            Apenas 169,90 <span style="font-size:12px !important"> / mês</span>
          </span>
          
          </v-card-text>


          <div class="ml-3 mb-2  text-center">
            <v-chip large color="blue" class="pa-5" @click="dialog_tabela=true, banner=false">
               <!-- <h3> Assinar Agora</h3> -->
               <h3>
                 Testar Grátis por 15 dias
                </h3>
            </v-chip>
          </div>


          

          <v-card-actions>
            <v-btn
              color="yellow lighten-2"
              text
              @click="show = !show"
            >
              Funcionalidades
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
              icon
              @click="show = !show"
            >
              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>


          <v-expand-transition>
          <div v-show="show">
            <v-divider></v-divider>

            <v-card-text>
              - Cadastro de Alunos<br/>
              - Controle de Pagamentos e Recebimentos <br/>
              - Previsão de Recebimentos <br/>
              - Imprima Contratos e Recibos com um clique <br/>
              - Acesse de qualquer lugar a qualquer hora <br/>
            
            </v-card-text>
          </div>
        </v-expand-transition>

        </v-img>
        </v-card>
      </template>


  <v-dialog v-model="dialog_modal"
      width="500"
      persistent
      scrollable
    >

      <v-card style="white-space: normal !important">
        <v-card-title class="text-h6 grey lighten-3 justify-center">
          {{dialog_modal_titulo}} 
        </v-card-title>

        <v-card-subtitle v-html="dialog_modal_subtitulo" class="text-subtitle-1 mt-4 pb-0 mb-0"/>


        <v-card-text class="">
          <!-- <v-img
            alt="user"
            :src="dialog_img_url"
            height="30%"
            v-if="(dialog_img_url)"
          >
         </v-img> -->

         <v-container class="mt-4">
         <v-row dense>
           <v-col cols="12" class="">
                <v-text-field
                v-model="comparar_codigo"
                label="Digite o Código Recebido"
                id="digite_codigo"
                ref="digite_codigo"
                outlined
                dense
                v-if="(codigo_celular) && (!codigo_ok)"
                hide-details=""
                class="ml-2"
                autofocus
                >
              
              </v-text-field>
          </v-col>
        </v-row>
      </v-container>

        </v-card-text>

        <v-card-actions class="pt-0">
          <!-- <v-btn
            color="primary"
            text
            x-large
            @click="saiba_mais_click(dialog_img_mais)"
            v-if="dialog_img_mais"
          >
            saiba mais
          </v-btn> -->

          <v-spacer></v-spacer>


          <v-btn
            color="primary"
            text
            x-large
            @click="dialog_modal = false, clicou_modal_fechar(dialog_modal_acao)"
          >
          {{ (dialog_modal_acao_name)? dialog_modal_acao_name : 'FECHAR' }}
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>

  <v-dialog v-model="dialog_tabela"
        persistent
        max-width="990"
        scrollable
        
    >
    <!-- :fullscreen="isMobile" -->

    <!-- <component :is="(0>1) ? 'v-dialog' : 'div' " class="janela2"> -->
      <!-- <div class="janela_dialog"> -->
        <v-card class="" >


          <v-overlay :value="overlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>



            <v-card class="ma-0" elevation="4" v-if="(acao_global=='401')">
              <v-container class="blue">
                <div class="text-center text-h6 font-weight-bold white--text" > {{ obj_empresa.nome }} </div>
              </v-container>
            </v-card>


          <v-card-title class="mb-2 ml-n2 grey lighten-4" >
            <!-- <span class="text-h4 font-weight-bold ">Gerenciador de Auto Escola</span> -->
            <!-- assinar contrato -->
            <span class="text-h6 font-weight-bold mr-5"> {{ etapa_texto }} </span>

                <v-chip-group v-if="(acao_global=='401')" class=""  >
                  <v-chip color="" > {{ obj_dados_chamada.x_NOME_FORNECEDOR }} </v-chip>
                  <v-chip color="" > {{ obj_dados_chamada.DESCRICAO }} </v-chip>
                  <v-chip color="" > {{ obj_dados_chamada.x_DATA }} </v-chip>
                  <v-chip color="" > {{ obj_dados_chamada.HORA }} </v-chip>
                </v-chip-group>

          </v-card-title>




            <!-- passo 4 monto os campos editaveis -->
            <!-- :readonly = "readonly" -->
                <v-card-text class="pa-1">
                  <v-form
                    ref="form"
                    v-model="valido"
                    >
                    <v-container id="meu-container">
                        <v-row >
                            <v-col
                                class=""
                                v-for="(item, i) in items_editaveis"
                                :key="i"
                                :cols="(isMobile) ? 12 : item.cols"
                                v-if="parseInt(item.cols)>0"   
                            >


                                <!-- {{ item_edita }} -->
                                <!-- {{ item_edita[item.value] }} -->
                                <div v-if="(item.tag == 'PATH_PDF')" class="px-0 ">
                                  <!-- <img :src="`/api/${item_edita.PATH_PDF}`" width="100%" alt="PATH_PDF" /> -->
                                  <img :src="`${url_geral}${item_edita.PATH_PDF}`" width="100%" alt="PATH_PDF" />


                                  <div  style="display: block; text-align: center; " class="white lighten-2 mb-5 fs-16" id="container-assinaturas">
                                    <!-- max-width: 70%; margin: 0 auto; -->
                                    <!-- v-if="(obj_clicado.IMG_ASSINATURA_1)" -->
                                      <v-row dense v-if="(item_edita.NOME)" class="">
                                        <v-col cols="6" class="">
                                            <img
                                              alt="ass_cadastro"
                                              :src="(item_edita.IMG_ASSINATURA_1)"
                                              width="30%"
                                              class="mb-n14"
                                              v-if="(item_edita.IMG_ASSINATURA_1)"
                                            />
                                            <div v-else>⠀</div>
                                            <h5>________________________________</h5>
                                            <h5> {{ item_edita.NOME }} </h5>

                                            <div v-if="(obj_DADOS_ASSINATURA_1.data_hora)">
                                                <div class="fs-12 silver--text">

                                                    <div>
                                                        Assinado Eletronicamente: {{ obj_DADOS_ASSINATURA_1.data_hora }}

                                                        <div v-if="0>1" @click="(obj_DADOS_ASSINATURA_1.latitude, obj_DADOS_ASSINATURA_1.longitude)" :class="[!obj_DADOS_ASSINATURA_1.latitude? 'red--text':'']">
                                                          Geolocalização: Lat.{{ obj_DADOS_ASSINATURA_1.latitude }} Long. {{ obj_DADOS_ASSINATURA_1.longitude }}
                                                        </div>

                                                        <div>
                                                            IP: {{ obj_DADOS_ASSINATURA_1.ip }}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </v-col>
                                        
                                        <v-col cols="6" class="">
                                            <img
                                              alt="ass_empresa"
                                              :src="(item_edita.IMG_ASSINATURA_2)"
                                              width="30%"
                                              class="mb-n14"
                                              v-if="(item_edita.IMG_ASSINATURA_2)"
                                            />
                                            <div v-else>⠀</div>
                                            <h5>________________________________</h5>
                                            <h5> {{ nome_empresa }} </h5>

                                            <!-- {{ item_edita }} -->
                                            <!-- {{ obj_DADOS_ASSINATURA_2 }} -->

                                            <div v-if="(obj_DADOS_ASSINATURA_2.data_hora)">
                                                <div class="fs-12 silver--text">

                                                    <div>
                                                        Assinado Eletronicamente: {{ obj_DADOS_ASSINATURA_2.data_hora }}

                                                        <div v-if="0>1" @click="(obj_DADOS_ASSINATURA_2.latitude, obj_DADOS_ASSINATURA_2.longitude)" :class="[!obj_DADOS_ASSINATURA_2.latitude? 'red--text':'']">
                                                          Geolocalização: Lat.{{ obj_DADOS_ASSINATURA_2.latitude }} Long. {{ obj_DADOS_ASSINATURA_2.longitude }}
                                                        </div>

                                                        <div>
                                                            IP: {{ obj_DADOS_ASSINATURA_2.ip }}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </v-col>
                                      </v-row>

                                  </div>

                                </div>


                                <div v-if="(item.tag == 'IMG_ASSINATURA_1')" class="px-0 ">

                                   <div v-if="(img_gerada)" class="">
                                      <!-- substituo o texto pela imagem -->
                                      <img v-if="img_gerada" :src="(img_gerada || '')" width="100%" alt="preview" class=""/>
                                      <!-- <img  :src=`'/api/'${item_edita.PATH_PDF}` width="100%" alt="preview" class=""/> -->
                                      <!-- <img :src="`/api/${item_edita.PATH_PDF}`" width="100%" alt="preview" /> -->

                                      <!-- <img  src="http://192.168.0.86/f/c/images/cfc_1013/SERVICOS/134.png" width="100%" alt="preview" class=""/> -->
                                   </div>
                                   <div v-else >
                                      <!-- mostra o texto -->
                                      <p v-html="item_edita[item.value]" :class="(isMobile)?'ma-0 fs-8':'ma-5'" class="" style="padding: 0 !important"></p>
                                   </div>

                                </div>  


                                
                                <p v-html="item_edita[item.value]" v-if="(item.tag == 'p')" class="pa-5 nao_editavelX " style="padding: 0 !important; "></p>



                                <span v-if="item.tag == 'img'" style="display: block; text-align: center;">
                                  <img
                                    alt="userr"
                                    :src="item_edita[item.value]"
                                    width="50%"
                                    />
                                </span>



                                <v-btn v-if="(item.tag == 'v-btn')" :color="item.color"
                                @click="modal_clicou(item.click)"
                                >
                                  {{item.text}}
                                </v-btn>


                                <span v-if="item.tag == 'span'" :class="[(item.color)? [item.color]+'--text' : '']">
                                  <b> {{ item.text }}</b>
                                </span>

                                <div v-if="item.grupo" class="mt-n7 pb-2">
                                  <b> {{ item.grupo }}</b>
                                </div>

                                <!-- COM V-MASK -->
                                <v-text-field 
                                    dense
                                    v-model="item_edita[item.value]"
                                    :label="item.rule == 'S' ? item.text+' *': item.text"
                                    :type="item.type"
                                    v-if="(item.tag == 'v-text') && (item.vmask)"
                                    @keyup="meu_keyup($event, item.value, item.upper)"
                                    :rules="item.rule == 'S' ? notnullRules: noRules"
                                    :autofocus="i==0"
                                    :hint="item.hint"
                                    v-mask = "getVmask(item.vmask)"
                                    @blur="clicou_em(item.blur)"
                                    :disabled="item.disabled ? $data[item.disabled] : false"
                                ></v-text-field>
                                
                                <!-- SEM V-MASK  acaba dando erro, por isso separei-->
                                <v-text-field
                                    dense
                                    v-model="item_edita[item.value]"
                                    :label="item.rule == 'S' ? item.text+' *': item.text"
                                    :type="item.type"
                                    v-if="(item.tag == 'v-text') && (!item.vmask)"
                                    @keyup="meu_keyup($event, item.value, item.upper)"
                                    :rules="item.rule == 'S' ? notnullRules: noRules"
                                    :autofocus="i==0"
                                    :hint="item.hint"
                                    @blur="clicou_em(item.blur)"
                                    :disabled="item.disabled ? $data[item.disabled] : false"
                                ></v-text-field>



                                <v-combobox
                                    dense
                                    v-model="item_edita[item.value]"
                                    :label="item.text"
                                    v-if="item.tag == 'v-combobox'"
                                    :items="item.tag_items"
                                    :rules="item.rule == 'S' ? notnullRules: noRules"
                                    @blur="item.upper == 'S' && maiusculo(item.value)"
                                ></v-combobox>
                                <!-- @blur="item_edita[item.value] = (item_edita[item.value] || '').toUpperCase()" -->
                                
                                <v-select
                                    :class="[item.class]"
                                    dense
                                    v-model="item_edita[item.value]"
                                    :label="item.text"
                                    v-if="item.tag == 'v-select'"
                                    :items="item.tag_items"
                                    :rules="item.rule == 'S' ? notnullRules: noRules"

                                    item-value='CODIGO'
                                    :item-text='item.tag_item_text'
                                    :clearable = "item.tag_clear == 'S'"
                                    :persistent-hint="item.cols>2"
                                    :hint="item.hint"
                                >
                                
                                <!-- <template slot="selection" v-slot-scope="item"> -->
                                  
                                <!-- <template slot="selection" v-slot-scope="item"> -->
                                  <template v-slot:label>
                                    <v-tooltip bottom v-if="item.hint">
                                        <template v-slot:activator="{ on, attrs }">
                                          <span
                                              v-bind="attrs"
                                              v-on="on"
                                          > 
                                            <span :class="item.class">
                                              {{ item.text }} 
                                              <!-- {{ item_edita[item.value] }} -->
                                            </span>
                                          </span>

                                        </template>
                                        <span> {{ item.hint }} </span>
                                      </v-tooltip>

                                      <span :class="item.class" v-else>
                                        {{ item.text }} 
                                      </span>
                                  </template>
      
                              </v-select>


                                <!-- CAMPO ANOTAÇÕES OU OBSERVAÇÃO -->
                                <v-textarea
                                  v-model="item_edita[item.value]"
                                  :label="item.text"
                                  v-if="item.tag == 'v-textarea'"
                                  :hint="item.hint"
                                  :persistent-hint="item.cols>2"
                                  :outlined="item.outlined=='S'"
                                  :filled="item.solo=='S'"
                                  :rows="item.rows"
                                  dense
                                  :rules="item.rule == 'S' ? notnullRules: noRules"
                                >
                                </v-textarea>


                                <!-- CAMPO ANOTAÇÕES OU OBSERVAÇÃO -->
                                <v-textarea
                                  v-model="item_edita[item.value]"
                                  label="TEXTO"
                                  v-if="item.tag == 'TEXTO'"
                                  persistent-hint="false"
                                  dense
                                  
                                  readonly
                                  auto-grow
                                  rows="18"
                                  class="pt-2"
                                  solo
                                  
                                >
                                <!-- rows="12" -->

                                  <!-- <template v-slot:label>
                                    <span class=""> {{(vai_imprimir) ? '' : item.text }} </span>
                                  </template>   -->
                                </v-textarea>

                                
                            </v-col>


                        </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

        <v-card-actions  v-if="(tabela_selecionada=='assinar_contrato')" class="grey lighten-4  ">
                
          
                  <v-checkbox
                    v-if="(!assinou) && ((qual_assinar==1) ?  !ja_IMG_ASSINATURA_1 : !ja_IMG_ASSINATURA_2)"
                    v-model="checkbox_aceito"
                    label="Assinar Documento"
                    dense
                    
                    class="ml-0 mb-2 "
                    hide-details="true" 
                    style="margin-left: 8px !important"  
                    @click="aceitar_termo(checkbox_aceito)"
                >
                    <template v-slot:label>
                        <span class="primary--text  bold">ACEITAR DOCUMENTO</span>
                        <!-- <v-btn color="primary" class="" small>
                          aceitar documento
                        </v-btn> -->
                    </template>

                    <!-- <template v-slot:label>
                        <span class="primary--text  bold">ACEITAR DOCUMENTO</span>
                    </template> -->

                </v-checkbox>



                  <!-- v-if="(assinou)||(ja_IMG_ASSINATURA_1)" -->
                  <v-btn 
                      @click="salvarComo('img_pdf','container-assinaturas','NAO_SALVAR', false, '1.5')"
                      color="red"
                      class="mr-3"
                      small dark
                  >
                  <!-- <v-icon color="" > mdi-file-pdf-box</v-icon> -->
                  PDF
                  </v-btn>


                <!-- v-if="(assinou)||(ja_IMG_ASSINATURA_1)" -->
                  <v-btn v-if="0>1"
                      @click="salvarComo('pdf','meu-container', '', false)"
                      color="primary"
                      class="mr-3"
                      small
                  >
                  <v-icon color="white" small> mdi-printer </v-icon>
                  &nbsp Imprimir
                  </v-btn>
                  

                  <v-btn v-if="0>1"
                      @click="salvarComo('img','meu-container', '', false)"
                      color="blue text--white"
                      class="mr-3"
                      small
                  >
                  <v-icon color="white" small> mdi-file-image </v-icon>
                  &nbsp Imagem
                  </v-btn>

                  <v-btn v-if="0>1"
                      @click="salvarComo('img','container-assinaturas', '', false)"
                      color="blue text--white"
                      class="mr-3"
                      small
                  >
                  <v-icon color="white" small> mdi-file-image </v-icon>
                  &nbsp Imagem ass
                  </v-btn>

          
                <v-spacer></v-spacer>

                <v-btn
                    color="primary"
                    text
                    @click="abrirNoGoogleMaps()"
                    class="mr-4"
                    v-if="(checkbox_aceito)&&(TESTE)"
                >
                  Mapa
                </v-btn>

                <v-btn
                    v-if="(checkbox_aceito)&&(!assinou)&&(aceitou_geo)"                    
                    color="primary"
                    @click="desenhar_assinatura('ALUNO')"
                    class="mr-4"
                >
                    <v-icon color="white" small class="pr-1">
                       <!-- mdi-pen  -->
                        mdi-pen-minus
                    </v-icon>
                <!-- v-if="(checkbox_aceito)" -->
                  Assinar
                </v-btn>



                <v-btn
                    color="red"
                    text
                    @click="dialog_tabela = false"
                    class="mr-4"
                >
                  fechar
                </v-btn>

              
        </v-card-actions>

        <v-card-actions v-else>

              <v-spacer></v-spacer>
              <v-btn
                  color="red"
                  text
                  @click="testar_email_zap()"
                  class="mr-4"
                  v-if="(TESTE)"
              >
                TESTE EMAIL E ZAP
              </v-btn>


              <v-btn
                  color="red"
                  text
                  @click="dialog_tabela = false, (banner = bd_here_cliente==0)"
                  class="mr-4"
              >
                Cancelar
              </v-btn>
              
              

              <v-btn
                :disabled="(!valido)"
                v-if="(!codigo_ok)"
                color="success"
                @click="receber_codigo(item_edita.CELULAR)"
                class="mr-2"
                >
                <v-icon left>
                    mdi-whatsapp
                </v-icon>
                Receber CÓDIGO
                </v-btn>
                          

              <v-btn
                  :disabled="!valido"
                  v-if="(codigo_ok)"
                  color="primary"
                  @click="botao_salvar(etapa)"
                  class="ml-2"
              >
                Salvar
              </v-btn>
        </v-card-actions>
        </v-card>
        <!-- </div> -->
    <!-- </component>   -->
  </v-dialog>

  </div>
</template>

<script>

import axios from "axios";
var url =  sessionStorage['url']

import {crud_sql_canal, crud_abrir_tabela_canal, crud_abrir_tabela_ponte, crud_sql_ponte} from '../assets/js/DSi_login'
import {get_data_hora,  gerar_token, consulta_cep, capturarIPeLocalizacao, salvarComoImagem,salvarComoPDF} from '../assets/js/DSi_basico'
import {imagemParaPDF, setMarginP_CSS, gerar_id, compartilharComoImagem} from '../assets/js/DSi_basico'
import { send_whats_api_45, enviar_email_45 } from '../assets/js/DSi_whats'

import SignaturePad from 'signature_pad';

export default {

  data: () => ({ 

    dialog_opcoes:false,
    items_opcoes :[], 
    items_opcoes_titulo:'',

    tipo_de_cliente:'',
    card_titulo:'',
    search: '',
    selected: [],
    items_lista:[],
    items_header: [],
    items_editaveis: [],
    obj_clicado : {},
    item_edita:  {"TIPO_CLIENTE": "CFC WEB"},
    // item_edita: { "CNPJ_CPF": "33.333.333/3333-33", "NOME": "NOVO CLIENTE", "TIPO_CLIENTE": "CFC WEB", "DIA_VENCIMENTO": "15", "CELULAR": "(44) 99968-5172", "EMAIL": "dsinaweb@gmail.com", "INDICACAO": "GOOGLE", "CEP": "87040-220", "ENDERECO": "rua das ruas ", "CIDADE": "maringa", "BAIRRO": "SAO PAULO", "UF": "PR", "FONE": "(44)3034-6479", "USER_USUARIO": "CLEBERSON ALVES", "USER_EMAIL": "dsinaweb@gmail.com", "USER_X_EMAIL": "dsinaweb@gmail.com" },


    ID_ONLINE_HERE:'',
    ocultar_print: false,

    dialog_data_table: false,
    dialog_comprovante: false,

    achou_cadastro: false,
    acao_global : '',

    qual_assinar:1,

    url_geral :  '',

    signatureDataURL: null,

    img_gerada:'',
    obj_empresa:{},
    obj_dados_aluno:{},
    obj_dados_chamada:{},

    dados_geo:{},
    obj_DADOS_ASSINATURA_1 : {},
    obj_DADOS_ASSINATURA_2 : {},

    assinou: false,
    ja_IMG_ASSINATURA_1: false,
    ja_IMG_ASSINATURA_2: false,

    REDIRECIONA: false,
    TESTE: false,

    nome_assinar:'',
    dialog_assinar:false,
    checkbox_aceito:false,
    aceitou_geo:false,

    nome_empresa:'',

    obj_dados_cliente:null,

    token: '',
    bd_here_cliente:'',


    versao_anterior: false,

    overlay: false,

    show: false,
    banner: false,
    dialog_tabela: false,
    tabela_selecionada:'',


    backgroundImage:'',

    dialog_modal: false,
    dialog_modal_titulo: '',
    dialog_modal_subtitulo: '',
    dialog_modal_acao :'',
    dialog_modal_acao_name :'',

    codigo_celular:'',
    comparar_codigo:'',
    codigo_ok: false,
    

    etapa: '',
    etapa_texto: '',    

    img_fundo:'http://localhost/images/black2.jpg',

    isMobile:false,
    

    valido: false,
  
    cor_fundo: '#273746',

    snackbar2: false,

    snackbar: false,
    snack_text1: "texto\ndois",
    snack_text2: "",
    snack_color: "success",
    snack_timeout: "3000",


    emailRules: [
         // v => !!v || 'necessário',
         v => /.+@.+\..+/.test(v) || 'E-mail inválido!',
    ],

    notnullRules: [
      v => !!v || 'necessário'
    ],

    noRules:[v => true],

  }),


  watch: {

      'item_edita.IMG_ASSINATURA_1'(a){
          // console.log('watch:', a);
         this.ja_IMG_ASSINATURA_1 = (a) ? true : false
      },

      'item_edita.IMG_ASSINATURA_2'(a){
          // console.log('watch:', a);
         this.ja_IMG_ASSINATURA_2 = (a) ? true : false
      },

      'item_edita.DADOS_ASSINATURA_1'(a){
        // console.log('watch:', a);
        if (a){
          //  if (a.DADOS_ASSINATURA_1){
           try{
             this.obj_DADOS_ASSINATURA_1 = JSON.parse(a)
           }
           catch(e){
             this.obj_DADOS_ASSINATURA_1 = {}
           }
        }
      },

      'item_edita.DADOS_ASSINATURA_2'(a){
        // console.log('watch:', a);
        if (a){
           try{
             this.obj_DADOS_ASSINATURA_2 = JSON.parse(a)
           }
           catch(e){
             this.obj_DADOS_ASSINATURA_2 = {}
           }
        }
      },


      REDIRECIONA(a){
        if (a){
           if (url =='/api/'){
              alert( 'Redireciona...')
           }
           else{
              window.location.replace("https://www.google.com") 
           }
           
        }
      },

      comparar_codigo(a){
          this.codigo_ok = (a == this.codigo_celular)

          if (this.codigo_ok){
            this.dialog_modal = false

            this.alertaAqui('Código Validado com sucesso!','Clique em Salvar para continuar','blue',3000)
          }
      }
  },

  created(){
    this.isMobile = window.innerWidth < 600
    this.onCreated()
  },


  methods:{


    async go_validar_cpf(){


      let sql = ``

      let quatro = this.obj_clicado.x_CPF.replace(/\D/g, '').slice(0, 4)
      if (quatro != this.items_opcoes.ID_CPF){
        alert('ID inválido!')
        this.items_opcoes.ID_CPF = ''

        return false
      }
      else{
        this.dialog_opcoes = false
      }


      sql = `update sub_agenda set visto = 'S', DATA_HORA_VISTO = '${this.go_get_data_hora()}' where codigo = ${this.obj_clicado.CODIGO}`

      let res =  await crud_sql_ponte(this.bd_here_cliente, sql )
      // console.log('res:', res);
      if (res.includes('sucesso')){
        this.tabela('sub_agenda', this.obj_dados_chamada.CODIGO)
      }

      alert('Presença Confirmada!')
      // this.alertaAqui('Confirmado','', 'green', 1000)
    },

    async abre_dialog_opcoes(qual){

        this.items_opcoes          = []//limpa
        this.items_opcoes_titulo   = qual


        if (qual == 'confirmar_presenca'){

           this.items_opcoes_titulo   = 'Confirmar Presença'
          // this.items_opcoes.push(    
          //     {type:'menu', title: 'Excluir',        icon:'mdi-close',   icon_color: 'red',        click:'remover_aula' },
          //     {type:'menu', title: 'Excluir Todos',   icon:'mdi-delete-circle-outline',   icon_color: 'red',        click:'remover_aula_todas' },
          // )      
        }

      this.dialog_opcoes = true
    },

    async vistar_chamada(bd_cliente, parte){
      
        await this.dados_cliente(bd_cliente)

        let dados_chamada = await this.abre_chamada(bd_cliente, parte)

        if (!dados_chamada){
            
          alert('Chamada não encontrada!')
          this.REDIRECIONA = true
        }
        else{
            this.obj_dados_chamada = dados_chamada
        }

        this.dialog_data_table = true

        this.card_titulo = dados_chamada.x_NOME_FORNECEDOR + ' - '+ dados_chamada.x_DATA + ' - '+dados_chamada.HORA
        // this.dialog_tabela = true
        this.tabela('sub_agenda', dados_chamada.CODIGO)


    },

    async abre_chamada(bd_cliente, parte){

      let codigo_chamada = parte[2] / 1984

      let sql = `
        SELECT 
            agenda.*,
            tabela_fornecedores.nome AS x_NOME_FORNECEDOR,
            (
                SELECT COUNT(sub_agenda.codigo)
                FROM sub_agenda
                WHERE sub_agenda.codigo_agenda = agenda.codigo
            ) AS x_JA_TEM
        FROM agenda
        LEFT JOIN tabela_fornecedores
            ON agenda.CODIGO_FORNECEDOR = tabela_fornecedores.codigo
        WHERE agenda.codigo = ${codigo_chamada}`

        // console.log('sql:',sql);
        let dados_chamada = await this.buscar_dados(bd_cliente, sql)
        return dados_chamada

    },

    go_get_data_hora(){
      return get_data_hora('data_hora')
    },

    async salvar_cadastro_chamada(){

      let dados = this.item_edita
      console.log('dados:', dados);

      this.overlay = true

     
      // VERIFICO SE JA TEM O NOME NA CHAMADA
      let sql2 = `
          SELECT 
              IFNULL(
                  (
                      SELECT CODIGO
                      FROM sub_agenda
                      WHERE codigo_agenda = ${this.obj_dados_chamada.CODIGO}
                      AND CODIGO_CADASTRO = (
                          SELECT CODIGO
                          FROM alunos
                          WHERE cpf = '${dados.CPF}'
                      )
                      LIMIT 1
                  ),
                  0
              ) AS CODIGO;`
      
      // console.log('sql2:', sql2);      
      let ja_tem = await this.buscar_dados(this.bd_here_cliente, sql2)
      if (ja_tem.CODIGO>0){
          alert('Seu Cadastro já esta na Chamada!')

          this.dialog_tabela = false
          this.overlay = false
          return false
      }
      


     
      // this.ID_ONLINE_HERE = await gerar_id(6,'', true)
      this.ID_ONLINE_HERE =  dados.CPF.replace(/\D/g, '').slice(0, 4)
     
      if (!dados.NOME_PIX){
          // dados.NOME_PIX = dados.NOME
      }
      

      // novo cadastro, verificando se ja existe ou nao
      let sql = `INSERT INTO alunos
 
        (
          CODIGO_ALUNO      ,
          STATUS            ,
          ATIVO             ,
          NOME              ,
          CPF               ,
          CELULAR           ,
          EMAIL             ,
          SEXO              ,
          DADOS_PIX         ,
          NOME_PIX          ,
          PROFISSAO         ,
          OBSERVACAO_2      ,
          OBSERVACAO_3      ,
          OBSERVACAO_4      ,
          DATA_CADASTRADO   
        )

       SELECT
      
         IFNULL((SELECT MAX(CODIGO_ALUNO) FROM alunos), 0) + 1,
        'ONLINE',
        'S',
        '${dados.NOME || ''}',
        '${dados.CPF || ''}',
        '${dados.CELULAR || ''}',
        '${dados.EMAIL || ''}',
        '${dados.SEXO || ''}',
        '${dados.DADOS_PIX || ''}',
        '${dados.NOME_PIX || ''}',
        '${dados.PROFISSAO || ''}',
        '${dados.OBSERVACAO_2 || ''}',
        '${dados.OBSERVACAO_3 || ''}',
        '${dados.OBSERVACAO_4 || ''}',
        '${get_data_hora('today')}'
      FROM
        DUAL
      WHERE
        NOT EXISTS (
          SELECT 1 FROM alunos WHERE CPF = '${dados.CPF}'
        );
      `

      // ja tem cadastro entao somente update
      if (this.achou_cadastro){
         sql = `update alunos set 
                  CELULAR       = '${dados.CELULAR}',
                  EMAIL         = '${dados.EMAIL}',
                  SEXO          = '${dados.SEXO}',
                  DADOS_PIX     = '${dados.DADOS_PIX}',
                  NOME_PIX      = '${dados.NOME_PIX}',
                  PROFISSAO     = '${dados.PROFISSAO}',
                  OBSERVACAO_2  = '${dados.OBSERVACAO_2}',
                  OBSERVACAO_3  = '${dados.OBSERVACAO_3}',
                  OBSERVACAO_4  = '${dados.OBSERVACAO_4}'
                where codigo = ${this.obj_dados_aluno.CODIGO}
                ;`
      }


      // console.log('sql:', sql);
      // return false



      // insiro na sub_agenda = chamada
      let sql_chamada = `INSERT INTO sub_agenda
 
        (
          CODIGO_AGENDA     ,
          CODIGO_CADASTRO   ,
          NOME              ,
          CONTATO           ,
          SITUACAO          ,
          VISTO             ,
          ID_ONLINE         ,
          DATA_CADASTRADO   
        )

       SELECT
      
        '${this.obj_dados_chamada.CODIGO}',
        (SELECT CODIGO FROM alunos where cpf = '${dados.CPF}'),
        '${dados.NOME}',
        '${dados.CELULAR}',
        'N',
        'N',
        '${this.ID_ONLINE_HERE}',
        '${get_data_hora('data_hora')}'
      FROM
        DUAL
      WHERE
        NOT EXISTS (
          SELECT 1 FROM sub_agenda WHERE codigo_agenda = ${this.obj_dados_chamada.CODIGO} and  CODIGO_CADASTRO = (SELECT CODIGO FROM alunos where cpf = '${dados.CPF}')
        );`

      // console.log('sql_chamada:', sql_chamada);  


      
      let res =  await crud_sql_ponte(this.bd_here_cliente, sql + sql_chamada)
      // console.log('res:', res);
      if (res.includes('sucesso')){
        // this.alertaAqui('Cadastro realizado com sucesso!','', 'blue', 2000)

        this.dialog_comprovante = true
      }
      else{
        this.alertaAqui('Algo não deu certo!','tente novamente mais tarde!', 'red', 3000)
        console.log('res:', res);
      }

        this.dialog_tabela = false

        this.overlay = false

    },



    async acha_nome(por){

        this.achou_cadastro = false

        let qual     = this.item_edita[por] || ''
        let sql      = ``
        let retornoo = null

        if (qual){
          sql = `select * from alunos where ${por} = '${qual}'`
          // console.log('sql:', sql);

          retornoo = await this.buscar_dados(this.bd_here_cliente, sql)
          if(retornoo){

              console.log('retornoo:', retornoo);
              this.achou_cadastro = true

              this.obj_dados_aluno = retornoo

              // ACHOU CADASTRO, JA PREENCHE OS DADOS
              if(this.acao_global=='401'){//novo cadastro via chamada

                // IMPEDE CANCELADOS DE SEREM ADICIONADOS NA CHAMADA
                if(retornoo.STATUS=='CANCELADO'){
                  alert('Chamada não disponível no momento!')
                  this.REDIRECIONA = true
                  return false
                }

                this.$set(this.item_edita, 'NOME'           , retornoo.NOME)
                this.$set(this.item_edita, 'CELULAR'        , retornoo.CELULAR)
                this.$set(this.item_edita, 'EMAIL'          , retornoo.EMAIL)
                this.$set(this.item_edita, 'DADOS_PIX'      , retornoo.DADOS_PIX)
                this.$set(this.item_edita, 'NOME_PIX'       , retornoo.NOME_PIX)
                this.$set(this.item_edita, 'PROFISSAO'      , retornoo.PROFISSAO)
                this.$set(this.item_edita, 'SEXO'           , retornoo.SEXO)
                this.$set(this.item_edita, 'OBSERVACAO_2'   , retornoo.OBSERVACAO_2)
                this.$set(this.item_edita, 'OBSERVACAO_3'   , retornoo.OBSERVACAO_3)
                this.$set(this.item_edita, 'OBSERVACAO_4'   , retornoo.OBSERVACAO_4)
              }


          }else{
            // alert('SEM CADASTRO')
            return false
          }
        }
    },

    async clicou_em(acao, item){
       

      await this.$nextTick()

        
      if (acao == 'validar_cpf'){
         this.go_validar_cpf()
      }

      else if (acao == 'clicou_nome'){
         if (this.acao_global==402){
            if (item.VISTO =='S'){
              alert('Presença já confirmada!')
              return false
            }
            await this.abre_dialog_opcoes('confirmar_presenca')
         }
      }

      else if (acao == 'FECHAR_JANELA'){
          window.close()
      }

      else if (acao == 'COMPARTILHAR_IMG'){

          let nome_img = this.ID_ONLINE_HERE || 'ABC' // salvo a img com o id_online

          this.ocultar_print = true

          // espera esconder elementos
          await this.$nextTick()

          let vv = await compartilharComoImagem('conteudo_impressao', nome_img)
          // alert(vv.file_path)
          // console.log('vv:', vv)

          setTimeout(() => {
              this.ocultar_print = false
          }, 1500)
      }
          

      else if (acao == 'SALVAR_IMG'){
        this.ocultar_print =  true
        this.salvarComo('img','conteudo_impressao', '', true)
        //  this.fechar_janela()


        setTimeout(async () =>{
            this.ocultar_print =  false
        }, 1500);

      }

      else if (acao == 'acha_nome'){
          this.acha_nome('CPF')
      }



    },

    async go_novo_cadastro(bd_cliente, parte){

      
      await this.dados_cliente(bd_cliente)

      let dados_chamada = await this.abre_chamada(bd_cliente, parte)

      if (dados_chamada){
          
          this.obj_dados_chamada = dados_chamada

          if ((dados_chamada.x_JA_TEM*1) >= (dados_chamada.LIMITE * 1)){

             alert('Chamada já atingiu o limite de pessoas!')
             this.REDIRECIONA = true
          }

      }else{
        alert('Chamada não encontrada!')
        this.REDIRECIONA = true
      }

        // return false
        // await this.dados_cliente(bd_cliente)

        await this.tabela('Aluno')

        this.codigo_ok = true
        this.dialog_tabela = true
        // this.dialog_comprovante = true
    },

    fotoComCacheBuster(url) {
      if (!url) return '';
      const separador = url.includes('?') ? '&' : '?';
      return `${url}${separador}t=${Date.now()}`;
    },


    async salvarComo(tipo, id, name, qualidade, escala){

      
      return new Promise((resolve) => {

        setTimeout(async () =>{

          let urlPDF = ``

          if (tipo=='img_pdf'){
              // await imagemParaPDF(id)

              let xx_img_ass = await  salvarComoImagem(id, name, qualidade, escala)

              let array_img = [this.url_geral + this.item_edita.PATH_PDF, xx_img_ass]
              urlPDF = await imagemParaPDF(array_img)

              if (urlPDF){
                // abrir pdf no navegador 
                window.open(urlPDF, "_blank");
              }
          }


          else if (tipo=='img'){

            let rr = await  salvarComoImagem(id, name, qualidade, escala)
            // console.log('rr:', rr);
            // this.img_gerada = rr
            // return rr
             resolve(rr)// = return

          }
          else if (tipo=='pdf'){

            urlPDF = await salvarComoPDF(id, name, qualidade)
            if (urlPDF){
              // abrir pdf no navegador 
              window.open(urlPDF, "_blank");
            }
          }
          else if (tipo=='assinatura'){


              if (!this.obj_dados_empresa.ASSINATURA_EMPRESA){
                alert(`É necessário Cadastrar a Assinatura da Empresa!\n\n1-Clique no menu Configurações, Empresa, ASSINATURA`)
                //  this.alerta(`<div style='text-align: left;'> É necessário Cadastrar a Assinatura da Empresa!<br/><br/> 1-Clique no menu Configurações <i class='mdi mdi-cogs'></i>, Empresa, ASSINATURA </div>`,'black', 5000)
                return false
              }

              this.msg_compartilhar = `\n\nLá poderá compartilhar o link via WhatsApp para Assinatura.\n\n`
              // tiro a logo e a linha assinatura antes de salvar a imagem, direto no botao acima (mostrar_assinatura, mostrar_logo)
              console.log('dados_servicos:', this.dados_servicos);
              console.log('dados_cadastro:', this.dados_cadastro);

              let pasta = 'WEB_REGISTROS/'
              let nome  = `${this.dados_servicos.CODIGO}.png`


              // pego o key_sql do registro
              let ss = await this.salvar_em_documentos()
              // console.log('ss:', ss);
              
              // pego o codigo do web_registros atraves do campo KEY_SQL
              let ssql = `select CODIGO from web_registros where KEY_SQL = '${ss}'`
              // console.log('ssql:', ssql);
              let get_codigo = await this.crud_abrir_tabela(ssql, false)
              get_codigo = get_codigo[0].CODIGO
              // console.log('get_codigo:', get_codigo);


              // salvo o nome do arquivo com o numero do web_servicos para referenciar quando necessario
              nome  = `${get_codigo}.png`

              let img = await salvarComoImagem('conteudo_impressao', 'NAO_SALVAR', qualidade, escala)//aqui salvo com boa qualidade
              // console.log('img:', img);
              
              
              let rr = await this.url_download_server_go('base64_upload', img, pasta + nome)
              if (rr){
                this.alerta(rr.mensagem,'green')

                this.ssPATH_PDF = rr.url_retorno

                let sql = `update web_registros set PATH_PDF = '${rr.url_retorno}' where codigo = ${get_codigo}`
                // console.log('sql:', sql);
                this.crud_sql(sql)
                
              }
              console.log('rr:', rr);

              // limpo a variavel
              this.ssPATH_PDF = ''
          }

        }, 100);

      })
      // setTimeout(function(){
      //     this.com_margem = false
      // }.bind(this), 1000);

    },


      async salvar_em_documentos(assinatura){

        if (!assinatura){
            if (!confirm("Este Texto será Salvo na guia ATENDIMENTO, REGISTROS. Deseja continuar?")){
              return false
            }
        }

        // console.log('assinatura:', assinatura);
        

            if (!assinatura){assinatura = ''}

            // defino o objeto inicial
            this[`obj_DADOS_ASSINATURA_${this.qual_assinar}`]  = 
              { 
                data_hora  : get_data_hora('data_hora'),
                ip         :'',
                latitude   :'',
                longitude  :'',
                cpf        :'',
              }

              
              // preencho o objeto caso pegue dados de geolocalizacao
            if (this.dados_geo && Object.keys(this.dados_geo).length > 0) {

               this.$set(this[`obj_DADOS_ASSINATURA_${this.qual_assinar}`], 'dados_geo',  this.dados_geo)
               this.$set(this[`obj_DADOS_ASSINATURA_${this.qual_assinar}`], 'ip',         this.dados_geo.ip)
               this.$set(this[`obj_DADOS_ASSINATURA_${this.qual_assinar}`], 'latitude',   this.dados_geo.localizacao?.latitude)
               this.$set(this[`obj_DADOS_ASSINATURA_${this.qual_assinar}`], 'longitude',  this.dados_geo.localizacao?.longitude)

            }
                        
            // console.log(`obj_DADOS_ASSINATURA_${this.qual_assinar}:`, this[`obj_DADOS_ASSINATURA_${this.qual_assinar}`] );
            


            // atualizo a assinatura
            if (assinatura){
                this.$set(this.item_edita, `IMG_ASSINATURA_${this.qual_assinar}` ,  assinatura)
            }


            let sql = `
            update 
             web_registros set 
              DADOS_ASSINATURA_${this.qual_assinar}  = '${JSON.stringify(this[`obj_DADOS_ASSINATURA_${this.qual_assinar}`] )}',
              IMG_ASSINATURA_${this.qual_assinar}    = '${assinatura}'
            where
              CODIGO = ${this.item_edita.CODIGO}
            `

            // console.log('sql:', sql);
            
            let res =  await crud_sql_ponte(this.bd_here_cliente, sql)
            // console.log('res:', res);
            if (res.includes('sucesso')){
                  this.alertaAqui2('Contrato Assinado com sucesso!','', 'green', 2000)
                  this.dialog_assinar  = false
                  this.assinou         = true 
            }
            else{
              this.alertaAqui('Algo não deu certo!','tente novamente mais tarde!', 'red', 3000)
            }
        
      },

      async aceitar_termo(aceitou){
         //capturar ip e geolocalizacao


          if (!aceitou){
            return false
          }


          if (!confirm(`Para Assinar eletronicamente é necessário permitir a geolocalização. Deseja continuar?`)){

              setTimeout(function(){
                this.checkbox_aceito = false
              }.bind(this), 111);
              
              return false
          }


          capturarIPeLocalizacao().then((dados) => {
            if (dados.erro) {

              this.aceitou_geo = false
              
              console.warn('Ops: ', dados.erro);
              alert('Ops: '+ dados.erro)

              if (confirm(`Para Assinar eletronicamente é necessário permitir a geolocalização.\n\n1-Tente Atualizar a página ou aperte F5 no teclado\n2-Tente fechar a janela e clicar no link novamente`)){


                location.reload();//F5 atualiza pagina


                // abrir nova guia
                // let route = this.$router.resolve({ path: this.$route.path });
                // window.open(route.href, '_blank');

                return false
              }

              
            } else {
              // console.log('IP:', dados.ip);
              console.log('dados_geo:', dados);
              console.log('Localização:', dados.localizacao);

              this.dados_geo   = dados
              this.aceitou_geo = true
            }
          });

      },

      abrirNoGoogleMaps(){
        if (!navigator.geolocation) {
                alert("Geolocalização não suportada pelo navegador.");
                return;
              }

              navigator.geolocation.getCurrentPosition(
                (position) => {
                  const lat = position.coords.latitude;
                  const lng = position.coords.longitude;

                  const url = `https://www.google.com/maps?q=${lat},${lng}`;
                  window.open(url, '_blank');
                },
                (error) => {
                  alert("Erro ao obter Geolocalização: " + error.message);
                }
              );
      },




      clearSignature() {
        this.signaturePad.clear();
      },

      saveSignature() {
        // Verifique se há uma assinatura para salvar


          // se for empresa e tiver assinatura, define por padrao
          if ((this.qual_assinar == 2) && (this.obj_empresa.ASSINATURA_EMPRESA)){
               this.signatureDataURL = this.obj_empresa.ASSINATURA_EMPRESA
          }
          else{

              if (this.signaturePad.isEmpty()) {
                alert('Por favor, assine primeiro!');
                return;
              }
              
              // Obtenha a representação base64 da assinatura
              this.signatureDataURL = this.signaturePad.toDataURL();

              //  console.log( this.signaturePad.toDataURL());

          }





        this.salvar_em_documentos(this.signatureDataURL)

        // Aqui você pode enviar this.signatureDataURL para o servidor ou fazer o que precisar com ela
        // Por exemplo, você pode criar um elemento de imagem e definir o src para this.signatureDataURL
        // Ou então, você pode enviar a representação base64 para o servidor para salvar em um banco de dados ou em um arquivo
     },


     desenhar_assinatura(tipo){


          if (tipo=='ALUNO'){
            this.nome_assinar = this.item_edita.NOME
          }

          this.dialog_assinar = true

          // limpo assinatura
          try{
              this.signaturePad.clear();
          }
          catch (e){}


          // executo o timer pq ele somente executa se o componente estiver visivel na tela = estar no DOM
          setTimeout(function(){
            

            try{
              this.signaturePad = new SignaturePad(this.$refs.canvas, {
                minWidth: 0.5, // Defina a largura mínima do traço para 2 pixels (ou qualquer valor desejado)
                penColor: 'black'
              });
            }
            catch (e) {}


            try{
              this.setCanvasWidth();
            } 
            catch (e){}

          }.bind(this), 500);
          

    },

    async go_abrir_contrato(bd_cliente, ide_contrato){
      // web_registros
        await this.dados_cliente(bd_cliente)

        await this.tabela('assinar_contrato', ide_contrato) 
        
        setTimeout(function(){
          this.dialog_tabela = true
        }.bind(this), 111);
    },


    async go_novo_aluno(bd_cliente){

        await this.dados_cliente(bd_cliente)

        await this.tabela('Aluno')

        this.codigo_ok = true
        this.dialog_tabela = true
    },

    async dados_cliente(ide){

      // alert(ide)
      let retorno   = null
      let sql_query = `select nome, ASSINATURA_EMPRESA from empresa`
      
      retorno = await crud_abrir_tabela_ponte( ide , sql_query)
      // console.log('dados_cliente:', retorno);

      this.nome_empresa = retorno[0].nome

      this.obj_empresa = retorno[0]

      if (!this.nome_empresa){
          // alert('...')
          window.location.replace("https://www.google.com") 
      }

    },

    async buscar_dados(ide, sql){

        let retorno = await crud_abrir_tabela_ponte(ide, sql)

        // console.log('buscar_dados:', retorno)

        // sem resultado
        if (!retorno || retorno.length === 0) {
            return false
        }

        // somente 1 linha
        if (retorno.length === 1) {
            return retorno[0]
        }

        // mais de 1 linha
        return retorno

    },

    transformarData(data) {
      // Divide a data no formato dd/mm/yyyy
      const [dia, mes, ano] = data.split('/');
      
      // Retorna a data no formato yyyy-mm-dd
      return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    },

    async trata_token(){

      // let vv = this.$route.params.token//pega o parametro do url
      let parametro = this.$route.params.token//pega o parametro do url
      let ide_aluno
      let bd_cliente
      let acao

      const parte = parametro.split("i");

      // console.log('parametro:', parametro);
      // console.log('parte:', parte[0]);
      // console.log('parte:', parte[1]);
      
      acao = parte[0]
      acao = (acao / 777888).toString();//transformo em string para verificar includes
      this.acao_global = acao 
      // alert(acao)

      // pego bd_cliente 
      // if ( ['201', '301'].some(el => acao.includes(el)) ){
      if (acao !='101'){
          
          bd_cliente = parte[1]//pega o codigo do bd cliente para conectar no bd
          bd_cliente = bd_cliente * 1 //transformo em numero
          

          if (!this.TESTE){
            bd_cliente = bd_cliente / 777888
          }

          //alert(bd_cliente)

          // verifica se é um numero inteiro valido
          if (Number.isInteger(bd_cliente)){
            this.bd_here_cliente = bd_cliente
          }
          else{
            console.log('opsss');
            this.REDIRECIONA = true
          }

      }



      // trata a acao
      if (acao == '101'){
          // novo cliente
          this.tabela('Conta')
          alert('Crie sua Conta gratuitamente, cancele quando quiser!')
          this.dialog_tabela = true
      }
      
      else if (acao == '201'){
          // novo aluno
          this.go_novo_aluno(bd_cliente)
      }

      else if (acao == '301'){
         //contrato
        let ide_contrato  = parte[2]
        ide_contrato      = ide_contrato * 1 

        // pega qual assinar IMG_ASSINATURA_1 ou IMG_ASSINATURA_2
        let ssi    = parte[3]
        ssi        = ssi / 1984

        if ((ssi!=1)&&(ssi!=2)){
           this.REDIRECIONA  = true
        }

        this.qual_assinar = ssi * 1
        

        if (!this.TESTE){
            ide_contrato = ide_contrato / 777888
        }
        
        // alert(ide_contrato)
        if (Number.isInteger(ide_contrato)){
            this.go_abrir_contrato(bd_cliente, ide_contrato)
        }
        else{
          this.REDIRECIONA = true
        }

      }

      else if (acao == '401'){
          // novo cadastro via chamada
          this.go_novo_cadastro(bd_cliente, parte)
      }

      else if (acao == '402'){
          // abre lista de chamada para dar visto
          this.vistar_chamada(bd_cliente, parte)
      }

      else{
        alert('ops')
        this.REDIRECIONA = true
      }

    },


    retorna_altura(menos){
        // let r = '100vh'
        // let r = '720'
        let r = (window.innerHeight - 80 - 60)
        let height = window.innerHeight;

        if (menos){
        r = (r - menos)
        }

        return r
    },

    async seleciona_linha(row) {
      // console.log('row:');
      // console.log(row);
      //  this.selected= [{"CODIGO" : row.CODIGO}] //via v-modal no data-table

      if (this.selected?.length <= 1){

          this.selected  = [ Object.assign({}, row)] 

          //clonando objeto
          this.obj_clicado = Object.assign({}, row)

          // this.item_menu = row

          
          if (this.tabela_selecionada == 'clientes'){
            this.cliente_selecionado  = Object.assign({}, row)
          }
      }


    },

    validarNumero(entra) {
      // Remove qualquer caractere que não seja número
      const valor = entra.replace(/[^0-9]/g, '');
      this.numero = valor;

      if (valor>0){
         return valor
      }
      else{
         return 0
      }

    },

    async testar_email_zap(){


      let senha = 'xxxx'
      let msg_whats = `
*Acesse*:
 *dsi.app.br*

 *Usuário:*  *Digite seu CPF*
 *Senha:*     ${senha}

*Vídeo de Demonstração do DSi CFC* 
 https://youtu.be/saMCoXXFuQg

Qualquer dúvida estaremos à disposição.
*Sistemas DSi*
          `

          //envia para o whatsapp tambem a senha
          let img = `https://dsi.app.br/logos/nova_dsi2.png`
          await send_whats_api_45('NOVO_CLIENTE', 'novo_cliente.vue', 'DSI -'+ 'nomeee' , '44999685172', msg_whats, null,null,img);//envia zap





          let msg_email = `Olá <b>{dados.USER_USUARIO}</b> sua senha provisória é: <b>${senha}</b> `
          // adicionou senha com sucesso..agora envia email
          try {

              if (rr =  await enviar_email_45('contato.dsi@gmail.com', 'Novo Login', msg_email)){
                  console.log('r:', rr);
                  if (rr == 'OK'){

                    this.abre_modal('Verifique seu E-mail', `Sua <b>senha</b> foi enviada para seu Email! <br> Verique sua caixa de <b>entrada</b> e também sua caixa de <b>Spam</b>`,'redirect', 'ACESSAR app')

                  }
                  else{
                    this.abre_modal('E-mail não enviado', 'Não foi possível enviar o e-mail','','')
                  }
              }

          } catch (error) {

            console.log('error:', error);

            setTimeout(function(){
              this.abre_modal(`Solicitando sua senha por e-mail`,`<br>Na janela de login do <b>App</b> clique em <b>Esqueci minha Senha</b> para que seja enviada uma nova senha para seu e-mail`,'redirect','acessar app')

            }.bind(this), 4000);
          }
          

    },

    oi(){
      // uso esse oi para testar aglo
      // this.avisa_zap_45('44999685172','Ola sec virtual pula ai vai')
    },

    async avisa_zap_45(numero, msg){

      const data = {
                acao:       'AVISAZAP',
                msg:         msg,
                numero:      numero,
                empresa:     'NOVO_CLIENTE',
      }  

      const header =   { headers: {'Content-Type': 'multipart/form-data', }}//se nao tiver esse header..da erro

      const res = await axios.post(url+'/clientes/forms.php', data, header)

      console.log('res:', res.data);
    },

    abre_modal(titulo, subtitulo, acao, btn_name){
      this.dialog_modal_titulo    = titulo
      this.dialog_modal_subtitulo = subtitulo
      this.dialog_modal           = true
      this.dialog_modal_acao      = acao
      this.dialog_modal_acao_name = btn_name
    },

    clicou_modal_fechar(acao){

      if (acao == 'redirect'){
        let link = "https://dsi.app.br"
        // window.location.replace(link) //impede retornar pelo historico
        location.href = link
      }

    },


    alertaAqui(text1, text2, color, time){

      if (!time){
          time = 2000
      }

      this.snackbar      = true;
      this.snack_text1   = text1;
      this.snack_text2   = text2;
      this.snack_color   = color;
      this.snack_timeout = time;

      if ( (text1?.includes('ERROR:')) || (text1?.includes('error'))){ 
          that.snack_color = 'red';
      }
    },

    alertaAqui2(text1, text2, color, time){

      if (!time){
          time = 2000
      }

      this.snackbar2      = true;
      this.snack_text1   = text1;
      this.snack_text2   = text2;
      this.snack_color   = color;
      this.snack_timeout = time;

      if ( (text1?.includes('ERROR:')) || (text1?.includes('error'))){ 
          that.snack_color = 'red';
      }
    },

    async receber_codigo(celular){
      
      this.abre_modal(`Verificação de Conta`, `Código enviado para o número ${this.item_edita.CELULAR}`)

      
      if (celular.length < 15){
          alert('Preencha o campo WhatsApp da Empresa!')
          return false
      }

      const token = Math.floor(Math.random() * 900000) + 100000;
      this.codigo_celular = token


      let texto = `*Sistemas DSi*:\n*${this.item_edita.NOME}* Seu código de verificação é *${token}*`

  

      let rrr = await send_whats_api_45('NOVO CLIENTE - VALIDAR', 'MODELO', 'DSI -'+this.item_edita.NOME , celular, texto);//envia zap
      console.log('rrr:', rrr);
      



      setTimeout(function(){
          this.focus_by_id('digite_codigo')
      }.bind(this), 222);
    },

    botao_salvar(etapa){

      if (etapa == 'Conta'){
        this.salvar_cadastro()
      }
      else if (etapa == 'Login'){
        this.salvar_senha()
      }
      else if ((etapa == 'Aluno') && (this.acao_global=='401')){
        this.salvar_cadastro_chamada()
      }
      else if (etapa == 'Aluno'){
        this.salvar_aluno()
      }
    },

    async onCreated(){

      this.url_geral =  sessionStorage['url']

      await this.trata_token()
      setMarginP_CSS(1)

      this.codigo_ok = this.TESTE
      

      if (this.TESTE){
            this.item_edita = { "CNPJ_CPF": "33.333.333/3333-33", "NOME": "NOVO CLIENTE", "TIPO_CLIENTE": "CFC WEB", "DIA_VENCIMENTO": "15", "CELULAR": "(44) 99968-5172", "EMAIL": "dsinaweb@gmail.com", "INDICACAO": "GOOGLE", "CEP": "87040-220", "ENDERECO": "rua das ruas ", "CIDADE": "maringa", "BAIRRO": "SAO PAULO", "UF": "PR", "FONE": "(44)3034-6479", "USER_USUARIO": "CLEBERSON ALVES", "USER_EMAIL": "dsinaweb@gmail.com", "USER_X_EMAIL": "dsinaweb@gmail.com", "RG" : "85990357", "CPF":"044.177.289-77", "DATA_NASCIMENTO" : "20/04/1984", "OBSERVACAO":"OBSERVACAO LOGICA"  }
      }


      // setTimeout(async () => {
      //    this.img_gerada =  await this.salvarComo('img','meu-container', 'NAO_SALVAR', true);
      // }, 999);


    },


    async focus_by_id(id){
       document.getElementById(id).focus();
    },


    //PASSO 3
    async tabela(tabela, codigo_a){


        // this.item_edita = {}//limpa
        this.tabela_selecionada = tabela
        this.etapa              = tabela//muda etapa

        //limpa array
        this.items_lista       = [] //recebe os dados do sql
        this.items_header      = [] //campos que tem que mostrar no header
        this.items_editaveis   = [] //campos editaveis mas nao tem que mostrar no header

        let retornoooo        = []

        if (tabela=='sub_agenda') {
            
            this.items_header = [
            
                // { text: '..', value: 'actions', sortable: false, type:'hide', cols:'0', width:'50px'},
                
                { text: 'NOME', value: 'NOME', tag:'v-text', type:'text', cols:'3', rule:'S',upper:'S', disabled:'S', width:'290px' },

                { text: 'PRESENÇA', value: 'VISTO',
                  type:'text',
                  tag:'v-select',
                  tag_items:[
                      'S',
                      'N',
                      ],
                      cols:'1',rule:'N' ,
                      hint:'Presente'
                },

                { text: 'CONTATO', value: 'CONTATO', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cel', width: '160px' },      
                { text: 'DATA_HORA_VISTO', value: 'DATA_HORA_VISTO', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cel', width: '160px' },      
                // { text: 'SEXO', value: 'x_SEXO', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cel', width: '150px' },      
                //  { text: 'CPF', value: 'x_CPF', tag:'v-text', type:'text', cols:'2', rule:'N',vmask:'cpf', width: '150px' },      
              ]

              // clono os items
            //   this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array
              this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array

              // METODO NOVO
              //edicao   
            //   this['items_editaveis'+nref] = this['items_editaveis'+nref].filter(x => x.value !== "NOME");
              this.items_editaveis = this.items_editaveis.filter(x => x.value !== "DATA_CADASTRADO");
              this.items_editaveis = this.items_editaveis.filter(x => x.value !== "x_SEXO");
              this.items_editaveis = this.items_editaveis.filter(x => x.value !== "x_CPF");

              let sql = `

                SELECT 
                    s.*,
                    a.CPF as x_CPF,
                    a.SEXO as x_SEXO,
                    a.DADOS_PIX as x_DADOS_PIX,
                    a.NOME_PIX as x_NOME_PIX,
                    a.PROFISSAO as x_PROFISSAO,
                    a.STATUS as x_STATUS,
                    a.EMAIL as x_EMAIL,
                    a.OBSERVACAO as x_OBSERVACAO,
                    a.OBSERVACAO_2 as x_OBSERVACAO_2,
                    a.OBSERVACAO_3 as x_OBSERVACAO_3,
                    a.OBSERVACAO_4 as x_OBSERVACAO_4

                FROM sub_agenda s

                LEFT OUTER JOIN alunos a 
                    ON s.CODIGO_CADASTRO = a.CODIGO

                WHERE s.CODIGO_AGENDA = ${codigo_a}

                ORDER BY s.CODIGO;`
              
              // console.log(tabela+': '+sql);
              retornoooo = await crud_abrir_tabela_ponte( this.bd_here_cliente , sql)
              if (retornoooo){
                  this.items_lista = retornoooo
              }
                      

        }

        else if (tabela=='assinar_contrato'){
           
          this.etapa_texto = 'Assinar Contrato'

          this.items_header = [

              { text: '..', value: 'actions', sortable: false, type:'hide', cols:'0',width:'30px'},
              // { text: 'CODIGO', value: 'CODIGO', tag:'v-text', type:'text', cols:'2', rule:'N' },  
              // { text: 'Descrição', value: 'NOME_TEXTO', tag:'v-text', type:'text', cols:'7',rule:'S', upper:'S' },
              // { text: 'Descrição', value: 'NOME_TEXTO', tag:'v-text', type:'text', cols:'7',rule:'S', upper:'S' },
              // { text: 'CONTEÚDO', value: 'TEXTO_REGISTRO',tag:'p', type:'text', class:'mx-15', cols:'12', rows:'19',rule:'N' },

              // { text: 'CONTEÚDO', value: 'TEXTO_REGISTRO',tag:'IMG_ASSINATURA_1', type:'text', class:'mx-15', cols:'12', rows:'19',rule:'N' },
              // { text: 'IMG_ASSINATURA_1', value: 'IMG_ASSINATURA_1',tag:'img', type:'img', class:'mx-15', cols:'12', rows:'19',rule:'N' },

              { text: 'PATH_PDF', value: 'PATH_PDF',tag:'PATH_PDF', type:'text', class:'mx-15', cols:'12', rows:'19',rule:'N' },
              
          ]

          // clono os items
          this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array


           let sql = `
           SELECT   
              a.NOME,
              a.CELULAR,
              a.CPF,
              a.DATA_NASCIMENTO,
              w.*
            FROM
              web_registros w
            INNER JOIN 
              alunos a ON w.CODIGO_CLIENTE = a.CODIGO_ALUNO
            WHERE 
              w.codigo = ${codigo_a};
           `

          //  console.log('sql:', sql);

          
           let retorno 
           if(retorno = await crud_abrir_tabela_ponte( this.bd_here_cliente , sql)){
              console.log('retorno:', retorno);
              this.items_lista = retorno.map((x) => x); //clonando array copiar array
              this.item_edita  = retorno[0]
           }

           console.log('item_edita:', this.item_edita);
           
        }

        else if (tabela=='Login'){

          this.etapa_texto = 'Cadastrar Login'
          this.items_header = [
              
              { text: 'Nome de Usuário'   ,  value: 'USER_USUARIO',tag:'v-text', type:'text', cols:'6',rule:'S' },
              { text: 'CPF'               ,  value: 'USER_CPF',tag:'v-text', type:'text', cols:'6', width: this.w_cpf, rule:'S', vmask:'cpf' },

              // { text: '',tag:'span',cols:'12'},//linha ou espaço quebra de linha

              // { text: 'Senha',           value: 'USER_SENHA',tag:'v-text', type:'text', cols:'3',rule:'S' },
              { text: 'Email',           value: 'USER_EMAIL',tag:'v-text', type:'text', cols:'6',rule:'S', hint:'Para recuperação de senha' },
              { text: 'Confirmar Email', value: 'USER_X_EMAIL',tag:'v-text', type:'text', cols:'6',rule:'S' },

              { text: 'A Senha será enviada para o seu e-mail',tag:'span',cols:'6', color:'blue'},//linha ou espaço

          ]

          // clono os items
          this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array

        }
        
        else if (tabela=='Conta'){


          this.etapa_texto = 'Cadastrar Conta'
          this.items_header = [
              
              // { text: 'Tipo', value: 'TIPO_CLIENTE',type:'text',tag:'v-select',tag_items:['CFC WEB','CFC','MEDCLINIC','CIVIC','CLINICA'],cols:'2', rule:'S', width:'90px'},
              
              { text: 'Nome da Empresa', value: 'NOME', tag:'v-text', type:'text', cols:'5', width: this.w_nome, rule:'S', width:'210px' },


              { text: 'CNPJ', value: 'CNPJ_CPF',tag:'v-text', type:'text', cols:'3', width: this.w_cnpj, rule:'S', vmask:'cnpj' },

              { text: 'WhatsApp Empresa', value: 'CELULAR',tag:'v-text', type:'text', cols:'2', width: this.w_fone, rule:'S',vmask:'cel' },
              { text: 'Fone Empresa', value: 'FONE',tag:'v-text', type:'text', cols:'2', width: this.w_fone, rule:'S',vmask:'fone' },
              { text: 'Dia Vencimento', value: 'DIA_VENCIMENTO',type:'text',tag:'v-select',tag_items:['10','15'],cols:'2', rule:'S'},

              { text: 'Email da Empresa', value: 'EMAIL',tag:'v-text', type:'text', cols:'6',rule:'S' },
          

              { text: 'Indicacao', value: 'INDICACAO',type:'text',tag:'v-select',tag_items:['GOOGLE','CLIENTES','WHATS','VENDEDOR','OUTROS'],cols:'2', rule:'N'},


              
              { text: 'CEP', value: 'CEP',tag:'v-text', type:'text', cols:'2',rule:'S',vmask:'cep' },
              { text: 'Endereço - Nº', value: 'ENDERECO',tag:'v-text', type:'text', cols:'5',rule:'S' },
              { text: 'Cidade', value: 'CIDADE',tag:'v-text', type:'text', cols:'3',rule:'S' },
              { text: 'Bairro', value: 'BAIRRO',tag:'v-text', type:'text', cols:'3',rule:'S' },
              { text: 'UF', value: 'UF',tag:'v-text', type:'text', cols:'1',rule:'S', upper:'S' },


              // { text: 'Seu nome de usuário', value: 'USUARIO',tag:'v-text', type:'text', cols:'2',rule:'S' },
              // { text: 'Email da Empresa', value: 'EMAIL',tag:'v-text', type:'text', cols:'4',rule:'S' },
              // { text: 'Senha', value: 'SENHA',tag:'v-text', type:'text', cols:'2',rule:'S' },
              // { text: 'Seu ', value: 'CNPJ_CPF',tag:'v-text', type:'text', cols:'3', width: this.w_cnpj, rule:'S', vmask:'cnpj' },
              // { text: 'CNPJ', value: 'CNPJ_CPF',tag:'v-text', type:'text', cols:'3', width: this.w_cnpj, rule:'S', vmask:'cnpj' },

              
          ]

          // clono os items
          this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array

        }
        
        else if ((tabela=='Aluno') && (this.acao_global=='401')){

          this.etapa_texto = 'Formulário de Chamada'
          this.items_header = [
              
              // { text: 'Tipo', value: 'TIPO_CLIENTE',type:'text',tag:'v-select',tag_items:['CFC WEB','CFC','MEDCLINIC','CIVIC','CLINICA'],cols:'2', rule:'S', width:'90px'},
              
              { text: 'CPF', value: 'CPF',tag:'v-text', type:'text', cols:'2', width: this.w_cnpj, rule:'S', vmask:'cpf', blur:'acha_nome', disabled:'achou_cadastro'},
              { text: 'Nome', value: 'NOME', tag:'v-text', type:'text', cols:'5', width: this.w_nome, rule:'S', width:'210px', disabled:'achou_cadastro' },
              // { text: 'Nascimento', value: 'DATA_NASCIMENTO',tag:'v-text', type:'text', cols:'2', width: this.w_cnpj, rule:'S', vmask:'data' },
              { text: 'WhatsApp', value: 'CELULAR',tag:'v-text', type:'text', cols:'2', width: this.w_fone, rule:'S',vmask:'cel' },
             
              { text: 'Cargo', value: 'PROFISSAO',
                    type:'text',
                    tag:'v-combobox',
                    tag_items:[
                        'AJ.GERAL',
                        '',
                    ],
                    cols:'3',rule:'N' ,
                    upper:'S',
                    rule:'S'
              },
             
              { text: 'Sexo', value: 'SEXO',
                    type:'text',
                    tag:'v-select',
                    tag_items:[
                        'MASCULINO',
                        'FEMININO',
                    ],
                    cols:'2',rule:'S' 
              },

              { text: 'Pix', value: 'DADOS_PIX',tag:'v-text', type:'text', cols:'3',rule:'S', upper:'N' },


              { text: 'Nome no Pix', value: 'NOME_PIX',tag:'v-text', type:'text', cols:'3',rule:'N', upper:'S', hint:'deixe em branco se for vc mesmo' },
              { text: 'Email', value: 'EMAIL',tag:'v-text', type:'text', cols:'4',rule:'N' },
              
              { text: 'Descreva suas Experiências na Área, suas Habilitades', value: 'OBSERVACAO_2',tag:'v-textarea', type:'text', cols:'12', rows:'3',outlined:'S', solo:'N', rule:'S', upper:'N' },
              { text: 'Quais Equipamentos de EPI possui?', value: 'OBSERVACAO_3',tag:'v-textarea', type:'text', cols:'6', rows:'5',outlined:'S', solo:'N', rule:'S', upper:'N' },
              { text: 'Possui alguma Restrição? Problema de Saúde ou Físico?', value: 'OBSERVACAO_4',tag:'v-textarea', type:'text', cols:'6', rows:'5',outlined:'S', solo:'N',rule:'N', upper:'N' },
              
          ]

          // clono os items
          this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array

        }
        
        else if (tabela=='Aluno'){

          this.etapa_texto = 'Cadastrar Aluno'
          this.items_header = [
              
              // { text: 'Tipo', value: 'TIPO_CLIENTE',type:'text',tag:'v-select',tag_items:['CFC WEB','CFC','MEDCLINIC','CIVIC','CLINICA'],cols:'2', rule:'S', width:'90px'},
              
              { text: 'Nome', value: 'NOME', tag:'v-text', type:'text', cols:'6', width: this.w_nome, rule:'S', width:'210px' },


              { text: 'RG', value: 'RG',tag:'v-text', type:'text', cols:'2', width: this.w_cnpj, rule:'S' },
              { text: 'CPF', value: 'CPF',tag:'v-text', type:'text', cols:'2', width: this.w_cnpj, rule:'S', vmask:'cpf' },
              { text: 'Nascimento', value: 'DATA_NASCIMENTO',tag:'v-text', type:'text', cols:'2', width: this.w_cnpj, rule:'S', vmask:'data' },

              { text: 'WhatsApp', value: 'CELULAR',tag:'v-text', type:'text', cols:'2', width: this.w_fone, rule:'S',vmask:'cel' },

              { text: 'Email', value: 'EMAIL',tag:'v-text', type:'text', cols:'6',rule:'S' },
          

              // { text: 'Indicacao', value: 'INDICACAO',type:'text',tag:'v-select',tag_items:['GOOGLE','CLIENTES','WHATS','VENDEDOR','OUTROS'],cols:'2', rule:'N'},


              
              { text: 'CEP', value: 'CEP',tag:'v-text', type:'text', cols:'2',rule:'S',vmask:'cep' },
              { text: 'Endereço - Nº', value: 'ENDERECO',tag:'v-text', type:'text', cols:'5',rule:'S' },
              { text: 'Cidade', value: 'CIDADE',tag:'v-text', type:'text', cols:'3',rule:'S' },
              { text: 'Bairro', value: 'BAIRRO',tag:'v-text', type:'text', cols:'3',rule:'S' },
              { text: 'UF', value: 'UF',tag:'v-text', type:'text', cols:'1',rule:'S', upper:'S' },

              { text: 'Observação', value: 'OBSERVACAO',tag:'v-text', type:'text', cols:'12',rule:'N', upper:'N' },

              
          ]

          // clono os items
          this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array

        }

        // setTimeout(function(){
        //   this.dialog_tabela = true
        // }.bind(this), 222);

    },

    async salvar_senha(){

      let dados = this.item_edita

      if ((dados.USER_EMAIL != dados.USER_X_EMAIL)){
        alert('E-mail não confere!')
        return false
      }

      this.overlay = true

      // const token = Math.floor(Math.random() * 900000) + 100000;
      let r = await gerar_token()
      r = r.slice(0, 6)
      r = r.toLowerCase()
      
      let senha = r
      
      console.log('today:', get_data_hora('today'));

      let sql = `INSERT INTO usuarios
 
        (
          ATIVO          ,
          DATA           ,
          CPF            ,
          EMAIL          ,
          NOME           ,
          SENHA          ,
          SUPER          ,
          NOME_CLIENTE   ,
          CODIGO_CLIENTE 

        )

       SELECT

        'S',
        '${get_data_hora('today')}' ,
        '${dados.USER_CPF}',
        '${dados.USER_EMAIL}',
        '${dados.USER_USUARIO}',
        '${senha}',
        'S',
        '${dados.NOME}',
        (SELECT CODIGO FROM clientes WHERE CNPJ_CPF = '${dados.CNPJ_CPF}' LIMIT 1);
       `

       // -------------------- SQL TESTE SO PARA DAR RETORNO E EXECUTAR OS ALERTAS
      //  sql = `update tarefas set codigo = 1 where codigo = 1`


      // console.log('sql:', sql);
      let res = null
      let rr  = null

      if(res =  await crud_sql_canal(sql)){
        console.log('res:', res);

        if (res.includes('sucesso')){

          this.alertaAqui(`Login salvo com sucesso!`, '', 'blue', 2000)

          
          // let msg_whats = `*Sistemas DSi*:\n*${this.item_edita.NOME}* Seu código de verificação é *${token}*`
          let msg_whats = `
*Acesse*:
 *dsi.app.br*

 *Usuário:*  *Digite seu CPF*
 *Senha:*     ${senha}

*Vídeo de Demonstração do DSi CFC* 
 https://youtu.be/saMCoXXFuQg

Qualquer dúvida estaremos à disposição 😉
*Sistemas DSi*
          `

          // ENVIA WHATS COM A SENHA
          // console.log('dados::', dados);
          //envia para o whatsapp tambem a senha
          let img = `https://dsi.app.br/logos/nova_dsi2.png`
          await send_whats_api_45('NOVO CLIENTE - VALIDAR', 'NOVO_CLIENTE.VUE', 'DSI -'+ dados.NOME , dados.CELULAR, msg_whats, null,null,img);//envia zap





          // ENVIA EMAIL COM A SENHA
          let msg_email = `Olá <b>${dados.USER_USUARIO}</b> sua senha provisória é: <b>${senha}</b> `
          // adicionou senha com sucesso..agora envia email
          try {

              if (rr =  await enviar_email_45(dados.USER_EMAIL, 'Novo Login', msg_email)){
                  console.log('r:', rr);
                  if (rr == 'OK'){

                    this.abre_modal('Verifique seu E-mail', `Sua <b>senha</b> foi enviada para seu Email e WhatsApp ! <br> Verique sua caixa de <b>entrada</b> e também sua caixa de <b>Spam</b>`,'redirect', 'ACESSAR app')

                  }
                  else{
                    this.abre_modal('E-mail não enviado', 'Não foi possível enviar o e-mail','','')
                  }
              }

          } catch (error) {

            setTimeout(function(){
              this.abre_modal(`Solicitando sua senha por e-mail`,`<br>Na janela de login do <b>App</b> clique em <b>Esqueci minha Senha</b> para que seja enviada uma nova senha para seu e-mail`,'redirect','acessar app')

            }.bind(this), 4000);
          }


        
        }

      }


      this.dialog_tabela = false
      this.overlay       = false
    },


    async salvar_aluno(){

      let dados = this.item_edita
      console.log('dados:', dados);
      
      // console.log('today:', get_data_hora('today'));


      // if (this.TESTE){//apago antes de add
      //    alert('delete from clientes codigo>431...')
      //    await crud_sql_canal(`delete from clientes where codigo >= 431; delete from usuarios where codigo >=40; delete from usuarios where codigo_cliente >=431;`)
      // }


      // verifico se ja tem cliente cadastrado com o cnpj
      let retorno   = null
      let sql_query = `SELECT CODIGO_ALUNO,ATIVO, NOME FROM alunos WHERE CPF = '${dados.CPF}'`
      // console.log('sql_query:', sql_query);
      if(retorno = await crud_abrir_tabela_ponte( this.bd_here_cliente , sql_query)){
        //  console.log('retorno:', retorno);
        //  console.log('retorno.length:', retorno.length);
         
         if (retorno.length>0){
          // ja tem cadastro

          this.alertaAqui(`CPF já Cadastrado: ${retorno[0].NOME}`,'','orange', 3000)
          
          // const retorno = await send_whats_api_45('NOVO CLIENTE', 'MODELO', 'DSI -'+dados.NOME , dados.CELULAR, `Ola`);//envia zap


          this.dialog_tabela = true

          if (!this.TESTE){
            return false
          }
          
         }
      }
      
      // return false
      
      this.overlay = true

      let nascimento
      try{
         nascimento = this.transformarData(dados.DATA_NASCIMENTO);
      } catch (error) {}

      // insere verificando se ja existe cnpj cadastrado..evitar duplicidade
      let sql = `INSERT INTO alunos
 
        (
          CODIGO_ALUNO      ,
          STATUS            ,
          ATIVO             ,
          NOME              ,
          CPF               ,
          RG                ,
          CELULAR           ,
          EMAIL             ,
          CEP               ,
          ENDERECO          ,
          CIDADE            ,
          BAIRRO            ,
          UF                ,
          OBSERVACAO        ,
          DATA_CADASTRADO   ,
          DATA_NASCIMENTO   
        )

       SELECT
      
         IFNULL((SELECT MAX(CODIGO_ALUNO) FROM alunos), 0) + 1,
        'ONLINE',
        'S',
        '${dados.NOME}',
        '${dados.CPF}',
        '${dados.RG}',
        '${dados.CELULAR}',
        '${dados.EMAIL}',
        '${dados.CEP}',
        '${dados.ENDERECO}',
        '${dados.CIDADE}',
        '${dados.BAIRRO}',
        '${dados.UF}',
        '${dados.OBSERVACAO}',
        '${get_data_hora('today')}',
        '${nascimento}'
      FROM
        DUAL
      WHERE
        NOT EXISTS (
          SELECT 1 FROM alunos WHERE CPF = '${dados.CPF}'
        );
      `




      // console.log('sql:', sql);
      // return false

      
      let res =  await crud_sql_ponte(this.bd_here_cliente, sql)
      // console.log('res:', res);
      if (res.includes('sucesso')){
        this.alertaAqui('Cadastro realizado com sucesso!','', 'blue', 2000)
          
    
        // manda zap me avisando de novo cliente
        // this.avisa_zap_45('44999685172',`*TESTAR CFC*:\n *${dados.NOME}* - ${dados.CIDADE}-${dados.UF}`)

        // this.tabela('Login')

      
      }
      else{
        this.alertaAqui('Algo não deu certo!','tente novamente mais tarde!', 'red', 3000)
      }

        this.dialog_tabela = false

        this.overlay = false

    },

    async salvar_cadastro(){

      let dados = this.item_edita
      // console.log('today:', get_data_hora('today'));



      if (!dados.EMAIL){
        alert('E-mail não definido!')
        return false
      }

      if ((!dados.CELULAR)){
        alert('WhatsApp não definido!')
        return false
      }



      if (this.TESTE){//apago antes de add
         alert('delete from clientes codigo>431...')
         await crud_sql_canal(`delete from clientes where codigo >= 1011; delete from usuarios where codigo >=176; delete from usuarios where codigo_cliente >=431;`)
      }


      // verifico se ja tem cliente cadastrado com o cnpj
      let retorno = null
      if(retorno = await crud_abrir_tabela_canal(`SELECT CODIGO,SITUACAO FROM clientes WHERE CNPJ_CPF = '${dados.CNPJ_CPF}'`)){
         console.log('retorno:', retorno);
         if (retorno.length>0){
          // ja tem cadastro

          this.alertaAqui('CNPJ já Cadastrado!','','orange', 3000)
          
          // const retorno = await send_whats_api_45('NOVO CLIENTE', 'MODELO', 'DSI -'+dados.NOME , dados.CELULAR, `Ola`);//envia zap


          this.dialog_tabela = true
          return false
         }
      }
      

      this.overlay = true

      // insere verificando se ja existe cnpj cadastrado..evitar duplicidade
      let sql = `INSERT INTO clientes
 
        (
          SITUACAO       ,
          NOME           ,
          CNPJ_CPF       ,
          TIPO_CLIENTE   ,
          DIA_VENCIMENTO ,
          CELULAR        ,
          FONE           ,
          INDICACAO      ,
          EMAIL          ,
          CEP            ,
          ENDERECO       ,
          CIDADE         ,
          BAIRRO         ,
          UF             ,
          BLOQUEAR       ,
          COBRANCA_WHATS ,
          FORMA_PAGAMENTO,
          DATA_CADASTRADO,
          DATA_TESTE_ACABA
        )

       SELECT
      
        'TESTE',
        '${dados.NOME}',
        '${dados.CNPJ_CPF}',
        '${dados.TIPO_CLIENTE}',
        '${dados.DIA_VENCIMENTO}',
        '${dados.CELULAR}',
        '${dados.FONE}',
        '${dados.INDICACAO}',
        '${dados.EMAIL}',
        '${dados.CEP}',
        '${dados.ENDERECO}',
        '${dados.CIDADE}',
        '${dados.BAIRRO}',
        '${dados.UF}',
        'N',
        'S',
        'BOLETO',
        '${get_data_hora('today')}',
        '${get_data_hora('quinze_dias')}'
      FROM DUAL
      WHERE NOT EXISTS (
        SELECT CODIGO FROM clientes WHERE CNPJ_CPF = '${dados.CNPJ_CPF}'
      );
      `


      let sql_assinatura = `INSERT INTO assinaturas
      (
        SITUACAO        ,
        DATA            ,
        DATA_REAJUSTAR  ,
        double_VALOR    ,
        SERVICO         ,
        REAJUSTE        ,
        CODIGO_CLIENTE  ,
        ANO_REAJUSTOU
      )
      VALUES(
        'TESTE'       ,
        '${get_data_hora('quinze_dias')}',
        '${get_data_hora('um_ano')}',
        '169.90',
        'ASSINATURA CFC',
        '15',
        (SELECT CODIGO FROM clientes WHERE CNPJ_CPF = '${dados.CNPJ_CPF}'),
        '${get_data_hora('ano_atual')}'
      );
      `
      // console.log('sql:', sql);
      // console.log('sql_assinatura:', sql_assinatura);

      
      let res =  await crud_sql_canal(sql + sql_assinatura)
      console.log('res:', res);
      if (res.includes('sucesso')){
        this.alertaAqui('Conta da Empresa realizada com sucesso!','', 'blue', 2000)
          
    
        // manda zap me avisando de novo cliente
        this.avisa_zap_45('44999685172',`*TESTAR CFC*:\n *${dados.NOME}* - ${dados.CIDADE}-${dados.UF}`)

        this.tabela('Login')

        setTimeout(function(){

          this.$set(this.item_edita, 'USER_CPF', '')//algum bug acaba trazendo os valores do campo CNPJ_CPF...nao sei resolver..ai estou apagando por aqui mesmo
          this.dialog_tabela = true
        }.bind(this), 3000);
      }
      else{
        this.alertaAqui('Algo não deu certo!','tente novamente mais tarde!', 'red', 3000)
      }

        this.dialog_tabela = false

        this.overlay = false

    },

    getVmask(qual,valor){
            
      // console.log('getVmask:', qual);return null

        if (qual == 'cel'){
            return "(##) #####-####"
        }
        else if (qual == 'fone'){
            return "(##) ####-####"
        }
        else if (qual == 'cnpj'){
            return "##.###.###/####-##"
        }
        else if (qual == 'cpf'){
            return "###.###.###-##"
        }
        else if (qual == 'cep'){
            return "#####-###"
        }
        else if (qual == 'data'){
            return "##/##/####"
        }
        else{
            return null
        }
    },


    maiusculo(campo){
        this.item_edita[campo] = (this.item_edita[campo] || '').toUpperCase()
    },

    async meu_keyup(event,campo,upper){
  
      
      //identifica se o campo é double e muda o display
      if ((campo.includes('double_') || campo.includes('VALOR')) ){
        this.item_edita[campo] =  this.moeda(event)
        // @keyup="editedItem.double_credito = moeda($event)"
      }
      else if (campo.includes('CEP')) {

        let retorno = null
        if(retorno = await consulta_cep(this.item_edita[campo])){
          // console.log('retorno:', retorno);

          this.$set(this.item_edita, 'ENDERECO', retorno.ENDERECO)
          this.$set(this.item_edita, 'CIDADE', retorno.CIDADE)
          this.$set(this.item_edita, 'BAIRRO', retorno.BAIRRO)
          this.$set(this.item_edita, 'UF', retorno.UF)
        }
      }
      else{
        if ((campo.includes('EMAIL')==false) &&
          (campo.includes('SENHA')==false) &&
          (campo.includes('SENHA_WEB')==false)){

            if (upper !=='N'){
              this.allUpper(event, campo)
            }
            
        }
      }
    },

    allUpper(event, field){
      let a = event.target.value;//captura o valor do event
      if (a!==''){  
          a = a.toUpperCase();
          this.item_edita[field] = a;
      } 
    },
  
    firstUpper(event, field){
      // console.log(event);
      let a = event.target.value;//captura o valor do event
      if (a!=='' && a.length==1){  
        a = a.toUpperCase();
        this.item_edita[field] = a;
      } 
    },



  },

}
</script>

<style scoped>


    .fs-7{
    font-size: 7px !important;
    }
    .fs-8{
        font-size: 8px !important;
    }
    .fs-9{
        font-size: 9px !important;
    }
    .fs-10{
        font-size: 10px !important;
    }
    .fs-11{
        font-size: 11px !important;
    }
    .fs-12{
        font-size: 12px !important;
    }
    .fs-13{
        font-size: 13px !important;
    }
    .fs-14{
        font-size: 14px !important;
    }
    .fs-15{
        font-size: 15px !important;
    }
    .fs-16{
        font-size: 16px !important;
    }
    .fs-17{
        font-size: 17px !important;
    }
    .fs-28{
        font-size: 28px !important;
    }
    .bold{
        font-weight: bold !important;
    }


 .v-main__wrap{
    background-color: #273746; 
 }

 .v-main__wrapX{
    /* background-color: #273746; Substitua pela cor desejada em formato hexadecimal, RGB ou nome de cor */

    background-image: url('http://localhost/bc.png'); /* Substitua pelo caminho da sua imagem */
    background-size: cover; /* Ajusta a imagem para cobrir todo o fundo */
    background-repeat: no-repeat; /* Evita repetição da imagem */
    background-attachment: fixed; /* Mantém a imagem fixa enquanto você rola a página */
  }

  .background-div2 {
  background-image: url('http://localhost/images/black2.jpg'); /* Substitua pelo caminho da sua imagem */
  background-size: cover; /* Redimensiona a imagem para cobrir toda a div */
  background-position: center; /* Centraliza a imagem na div */
  width: 100%;
  height: 100vh; /* Tamanho total da tela */   
 }

 .background-div {
  background: linear-gradient(to bottom, #330033, #000066);
  margin: 0;
  padding: 0;
  height: 100vh;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  color: #fff; /* Define a cor do texto para branco ou outra cor visível. */
  font-family: Arial, sans-serif; /* Define a fonte desejada. */
}


.janela_dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  padding: 20px;
  overflow: auto;
  z-index: 9999;
}


@media print {
  .janela_dialog {
    position: static !important;
    transform: none !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: auto !important;
    max-height: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    overflow: visible !important;
    padding: 0 !important;
  }
}


div[contenteditable="false"] {
  user-select: none;
  pointer-events: none;
}

.nao_editavel{
    user-select: none;
    pointer-events: none;
}


</style>
 